import { useEffect, useState, useRef, useMemo, useCallback } from "react";
import waveLogo from '../media/waveLogo.png';
import logo from '../media/holy-threads-wide.png';
import waveImg from "../media/waves-white.png";
import oversizedSizeGuide from "../media/oversized-size-guide.png";
import hoodieSizeGuide from "../media/hoodie-size-guide.png";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y, Navigation, EffectFade, Keyboard, Mousewheel } from 'swiper/modules';
import "../styles/navbar.css";
import "../styles/sidebar.css";
import "../styles/global.css";
import "../styles/account.css";
import "../styles/orders.css";
import "../styles/cartncheckout.css";
import "../styles/item.css";
import "../styles/product.css";
import "../styles/glass.css";
import "../styles/inputs.css";
import "../styles/buttons.css";
import "../styles/ordermsg.css";


// Components

import ItemImg from "../components/itemImg.js";
import ItemDesc from "../components/itemDesc.js";

const AUTH_RETURN_MODE_KEY = "holy_threads_auth_return_mode";
//  ############################################# PASSWORD SECURITY #######################################################
const PasswordField = ({
    className = "",
    id,
    ...inputProps
}) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="password-field">
            <button
                type="button"
                className="password-visibility-button"
                aria-label={isVisible ? "Hide password" : "Show password"}
                aria-pressed={isVisible}
                aria-controls={id}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setIsVisible(prev => !prev)}
            >
                {isVisible ? (
                    <svg
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        className="password-eye-icon"
                    >
                        <path
                            d="M3 3l18 18M10.6 10.7a2 2 0 002.7 2.7M9.9 4.2A10.8 10.8 0 0112 4c5.5 0 9 5 9 5a16.8 16.8 0 01-2.1 2.6M6.6 6.7C4.3 8.2 3 10 3 10s3.5 5 9 5a10.7 10.7 0 004.1-.8"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                ) : (
                    <svg
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        className="password-eye-icon"
                    >
                        <path
                            d="M3 12s3.5-5 9-5 9 5 9 5-3.5 5-9 5-9-5-9-5z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />

                        <circle
                            cx="12"
                            cy="12"
                            r="2.5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                        />
                    </svg>
                )}
            </button>

            <input
                {...inputProps}
                id={id}
                type={isVisible ? "text" : "password"}
                className={`password-field-input ${className}`.trim()}
            />
        </div>
    );
};


export const Home = ({ isModalUp, setIsModalUp }) => {

    const MODES = {
        HOME: "home",
        ITEM: "item",
        ADDED: "added",
        CART: "cart",
        CARTJUMP: "cartjump",
        ACCOUNT: "account",
        SIGNUP: "signup",
        CHECKOUT: "checkout",
        DEFAULT_ADDR: "default_addr",
        ADD_ADDR: "add_addr"
    };
    const [mode, setMode] = useState(MODES.HOME);


    // api location
    const baseURL = process.env.NODE_ENV === "production" ? "/api" : "http://localhost:5000/api";

    // for context
    const [colunmSize, setColumnSize] = useState([3, 5]); // the columns available
    const [colunmIndex, setColumnIndex] = useState(0); // index selecting current column size
    const [isMobile, setIsMobile] = useState(false); // Temp: toggle ifMobile

    // for Modals
    const [isLeftOpen, setIsLeftOpen] = useState(false);
    const [isRightOpen, setIsRightOpen] = useState(false);

    // The BUTTON
    const [chevron, setChevron] = useState(true);

    // item selected
    const [clothes, setClothes] = useState([]);// array of clothes
    const [itemIndex, setItemIndex] = useState(0);// index of the clothes selected
    const itemSelected = clothes[itemIndex]; // the clothes selected
    const [selectedVariant, setSelectedVariant] = useState(null);// the items cariant selected
    const swiperIndex = useRef(null); // swiper Index

    // Users
    const [currentUser, setCurrentUser] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const [signupError, setSignupError] = useState("");
    const [loginSubmitting, setLoginSubmitting] = useState(false);
    const [signupSubmitting, setSignupSubmitting] = useState(false);
    const [forgotPasswordSubmitting, setForgotPasswordSubmitting] = useState(false);
    const [resetPasswordSubmitting, setResetPasswordSubmitting] = useState(false);
    const [oauthSubmitting, setOAuthSubmitting] = useState("");
    const loginInFlightRef = useRef(false);
    const signupInFlightRef = useRef(false);
    const forgotPasswordInFlightRef = useRef(false);
    const resetPasswordInFlightRef = useRef(false);
    const oauthInFlightRef = useRef(false);

    // password rules
    const passwordRules = {
        length: password.length >= 8,
        upper: /[A-Z]/.test(password),
        lower: /[a-z]/.test(password),
        number: /[0-9]/.test(password),
        special: /[^A-Za-z0-9]/.test(password)
    };

    const passwordScore = Object.values(passwordRules).filter(Boolean).length;

    const passwordsMatch =
        password &&
        confirmPassword &&
        password === confirmPassword;

    const passwordIsStrong = passwordScore === 5 && passwordsMatch;

    const showPasswordMismatch =
        password &&
        confirmPassword &&
        confirmPassword.length >= password.length &&
        password !== confirmPassword;

    const getPasswordStrengthText = () => {
        if (!password) return "";
        if (passwordScore <= 2) return "Weak";
        if (passwordScore <= 4) return "Good";
        return "Strong";
    };

    // icons
    const GoogleIcon = () => (
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width="16"
            height="16"
            className="google-icon"
        >
            <path
                d="M8.00018 3.16667C9.18018 3.16667 10.2368 3.57333 11.0702 4.36667L13.3535 2.08333C11.9668 0.793333 10.1568 0 8.00018 0C4.87352 0 2.17018 1.79333 0.853516 4.40667L3.51352 6.47C4.14352 4.57333 5.91352 3.16667 8.00018 3.16667Z"
                fill="#EA4335"
            />
            <path
                d="M15.66 8.18335C15.66 7.66002 15.61 7.15335 15.5333 6.66669H8V9.67335H12.3133C12.12 10.66 11.56 11.5 10.72 12.0667L13.2967 14.0667C14.8 12.6734 15.66 10.6134 15.66 8.18335Z"
                fill="#4285F4"
            />
            <path
                d="M3.51 9.53001C3.35 9.04668 3.25667 8.53334 3.25667 8.00001C3.25667 7.46668 3.34667 6.95334 3.51 6.47001L0.85 4.40668C0.306667 5.48668 0 6.70668 0 8.00001C0 9.29334 0.306667 10.5133 0.853333 11.5933L3.51 9.53001Z"
                fill="#FBBC05"
            />
            <path
                d="M8.0001 16C10.1601 16 11.9768 15.29 13.2968 14.0633L10.7201 12.0633C10.0034 12.5467 9.0801 12.83 8.0001 12.83C5.91343 12.83 4.14343 11.4233 3.5101 9.52667L0.850098 11.59C2.1701 14.2067 4.87343 16 8.0001 16Z"
                fill="#34A853"
            />
        </svg>
    );

    // facebook icon
    const FacebookIcon = () => (
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            className="facebook-icon"
        >
            <rect
                x="0"
                y="0"
                width="24"
                height="24"
                rx="6"
                fill="#1877F2"
            />

            <path
                d="M15.7 12.7L16.1 10H13.5V8.25C13.5 7.5 13.86 6.78 15.04 6.78H16.22V4.48C16.22 4.48 15.15 4.3 14.13 4.3C12 4.3 10.61 5.59 10.61 7.93V10H8.25V12.7H10.61V19.22H13.5V12.7H15.7Z"
                fill="white"
            />
        </svg>
    );
    // full screen stuff
    // full screen stuff
    const [fullscreenImage, setFullscreenImage] = useState(null);
    const [fullscreenIndex, setFullscreenIndex] = useState(0);
    const [fullscreenType, setFullscreenType] = useState("product");

    const ENABLE_FULLSCREEN_VERTICAL_SWIPE_CLOSE = false;

    const fullscreenIndexRef = useRef(0);

    useEffect(() => {
        fullscreenIndexRef.current = fullscreenIndex;
    }, [fullscreenIndex]);

    const imageTouchRef = useRef({
        x: 0,
        y: 0,
        time: 0,
        url: null,
        index: 0
    });

    const lastImageTapRef = useRef({
        url: null,
        time: 0
    });

    const fullscreenTouchRef = useRef({
        x: 0,
        y: 0,
        time: 0,
        active: false,
        multiTouch: false
    });

    // Prevent a click from firing immediately after a pinch.
    const suppressFullscreenClickUntilRef = useRef(0);

    const resetFullscreenTouchGesture = () => {
        fullscreenTouchRef.current = {
            x: 0,
            y: 0,
            time: 0,
            active: false,
            multiTouch: false
        };
    };

    const slideProductCarouselTo = (index, speed = 0) => {
        const swiper = swiperIndex.current;

        if (!swiper || swiper.destroyed) return;

        const safeIndex = Math.max(0, Number(index) || 0);

        swiper.update?.();

        if (typeof swiper.slideToLoop === "function") {
            swiper.slideToLoop(safeIndex, speed, false);
            return;
        }

        swiper.slideTo(safeIndex, speed, false);
    };

    const openFullscreenImage = (e, url, index = 0) => {
        e.preventDefault();
        e.stopPropagation();

        setFullscreenType("product");
        setFullscreenImage(url);
        setFullscreenIndex(index);
        fullscreenIndexRef.current = index;

        slideProductCarouselTo(index, 0);
    };

    const getSizeGuideImage = (product) => {
        const description = product?.description?.trim() || "";

        if (description.startsWith("T-Shirt Oversized fit")) {
            return oversizedSizeGuide;
        }

        if (description.startsWith("Recycled Hoodie")) {
            return hoodieSizeGuide;
        }

        return null;
    };

    const hasSizeGuide = (product) => {
        return Boolean(getSizeGuideImage(product));
    };

    const openSizeGuideFullscreen = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const sizeGuideImage = getSizeGuideImage(itemSelected);

        if (!sizeGuideImage) return;

        setFullscreenType("size-guide");
        setFullscreenImage(sizeGuideImage);
    };

    const closeFullscreenImage = () => {
        if (fullscreenType === "product") {
            slideProductCarouselTo(fullscreenIndexRef.current, 0);
        }

        setFullscreenImage(null);
        setFullscreenType("product");

        if (mode === MODES.ITEM || mode === MODES.ADDED) {
            setMode(MODES.ITEM);
        }
    };
    const handleImageTouchStart = (e, url, index = 0) => {
        const touch = e.touches?.[0];
        if (!touch) return;

        imageTouchRef.current = {
            x: touch.clientX,
            y: touch.clientY,
            time: Date.now(),
            url,
            index
        };
    };

    const handleImageTouchEnd = (e, url, index = 0) => {
        const touch = e.changedTouches?.[0];
        if (!touch) return;

        const start = imageTouchRef.current;

        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;

        const moved =
            Math.abs(dx) > 10 ||
            Math.abs(dy) > 10;

        if (moved) return;

        const now = Date.now();
        const lastTap = lastImageTapRef.current;

        const isDoubleTap =
            lastTap.url === url &&
            now - lastTap.time < 320;

        if (isDoubleTap) {
            openFullscreenImage(e, url, start.index ?? index);

            lastImageTapRef.current = {
                url: null,
                time: 0
            };

            return;
        }

        lastImageTapRef.current = {
            url,
            time: now
        };
    };

    const moveFullscreenImage = (direction) => {
        const images = itemSelected
            ? getAllImages(itemSelected, selectedVariant?.color)
            : [];

        if (!images.length) return;

        const currentIndex = fullscreenIndexRef.current;

        const nextIndex =
            direction === "next"
                ? (currentIndex + 1) % images.length
                : (currentIndex - 1 + images.length) % images.length;

        setFullscreenIndex(nextIndex);
        fullscreenIndexRef.current = nextIndex;

        setFullscreenImage(images[nextIndex]);

        slideProductCarouselTo(nextIndex, 0);
    };

    const rejectFullscreenMultiTouch = () => {
        fullscreenTouchRef.current.multiTouch = true;
        fullscreenTouchRef.current.active = false;

        // Some mobile browsers emit a click after pinch ends.
        suppressFullscreenClickUntilRef.current = Date.now() + 500;
    };

    const handleFullscreenTouchStart = (e) => {
        const touches = e.touches;

        if (!touches?.length) return;

        // A second finger entered: reject the entire gesture.
        if (touches.length > 1) {
            rejectFullscreenMultiTouch();
            return;
        }

        const touch = touches[0];

        fullscreenTouchRef.current = {
            x: touch.clientX,
            y: touch.clientY,
            time: Date.now(),
            active: true,
            multiTouch: false
        };
    };

    const handleFullscreenTouchMove = (e) => {
        // Detect a pinch even when the second finger is added
        // after the initial touchstart.
        if (e.touches?.length > 1) {
            rejectFullscreenMultiTouch();
        }
    };

    const handleFullscreenTouchEnd = (e) => {
        const gesture = fullscreenTouchRef.current;

        /*
         * Never turn a pinch into a swipe.
         *
         * Keep multiTouch true until every finger has been lifted.
         */
        if (gesture.multiTouch) {
            suppressFullscreenClickUntilRef.current = Date.now() + 500;

            if (!e.touches?.length) {
                resetFullscreenTouchGesture();
            }

            return;
        }

        /*
         * Another finger is still touching the screen.
         * Reject the gesture even if touchstart/touchmove missed it.
         */
        if (e.touches?.length > 0) {
            rejectFullscreenMultiTouch();
            return;
        }

        if (!gesture.active) {
            resetFullscreenTouchGesture();
            return;
        }

        const touch = e.changedTouches?.[0];

        if (!touch) {
            resetFullscreenTouchGesture();
            return;
        }

        const dx = touch.clientX - gesture.x;
        const dy = touch.clientY - gesture.y;

        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        resetFullscreenTouchGesture();

        // Ignore taps and small accidental movement.
        if (absX < 45 && absY < 45) {
            return;
        }

        // Size guides do not respond to swipe gestures.
        if (fullscreenType === "size-guide") {
            return;
        }

        // Horizontal swipe changes the product image.
        if (absX > absY) {
            e.preventDefault();
            e.stopPropagation();

            if (dx < 0) {
                moveFullscreenImage("next");
            } else {
                moveFullscreenImage("prev");
            }

            return;
        }

        if (ENABLE_FULLSCREEN_VERTICAL_SWIPE_CLOSE) {
            e.preventDefault();
            e.stopPropagation();
            closeFullscreenImage();
        }
    };

    const handleFullscreenTouchCancel = () => {
        resetFullscreenTouchGesture();
    };

    const handleFullscreenOverlayClick = (e) => {
        // Ignore synthetic clicks generated after pinch gestures.
        if (Date.now() < suppressFullscreenClickUntilRef.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        closeFullscreenImage();
    };

    const isOversizedTShirtDescription = (product) => {
        return product?.description
            ?.trim()
            .startsWith("T-Shirt Oversized fit");
    };

    // escape key close
    useEffect(() => {
        if (!fullscreenImage) return;

        const closeOnEscape = (e) => {
            if (e.key === "Escape") {
                closeFullscreenImage();
            }
        };

        document.addEventListener("keydown", closeOnEscape);

        return () => {
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, [fullscreenImage]);



    //  ############################################# COMMON FUNCTIONS ###################################################
    // refresh fetch 

    // animate the button presses
    const animateThen = (callback) => (e) => {
        const btn = e.currentTarget;

        btn.classList.add("pressed");

        setTimeout(() => {
            callback?.();
            btn.classList.remove("pressed");
        }, 77);
    };

    // anime the headers 
    const animateLongThen = (callback) => (e) => {
        const btn = e.currentTarget;

        btn.classList.add("pressed");

        setTimeout(() => {
            callback?.();
            btn.classList.remove("pressed");
        }, 8);
    };

    const authFetch = async (url, options = {}) => {

        // =====================================
        // PREVENT INFINITE REFRESH LOOP
        // =====================================
        if (url.includes("/users/refresh")) {

            return fetch(url, {
                ...options,
                credentials: "include"
            });
        }

        // =====================================
        // GET ACCESS TOKEN
        // =====================================
        let token = localStorage.getItem("token");

        // =====================================
        // FIRST REQUEST
        // =====================================
        let res = await fetch(url, {
            ...options,

            credentials: "include",

            headers: {
                ...(options.headers || {}),
                Authorization: `Bearer ${token}`
            }
        });

        // =====================================
        // TOKEN STILL VALID
        // =====================================
        if (res.status !== 401) {
            return res;
        }

        console.warn("Access token expired. Attempting refresh...");

        // =====================================
        // REFRESH ACCESS TOKEN
        // =====================================
        const refreshRes = await fetch(
            `${baseURL}/users/refresh`,
            {
                method: "POST",

                credentials: "include",

                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        // =====================================
        // REFRESH FAILED
        // =====================================
        if (!refreshRes.ok) {

            console.error("Refresh failed");

            localStorage.removeItem("token");

            return Promise.reject("AUTH_EXPIRED");
        }

        // =====================================
        // PARSE REFRESH RESPONSE
        // =====================================
        let refreshData;

        try {

            refreshData = await refreshRes.json();

        } catch (err) {

            console.error(
                "Failed to parse refresh response:",
                err
            );

            localStorage.removeItem("token");

            return Promise.reject("AUTH_EXPIRED");
        }

        // =====================================
        // VALIDATE RESPONSE
        // =====================================
        if (
            !refreshData?.success ||
            !refreshData?.data?.token
        ) {

            console.error(
                "Invalid refresh response:",
                refreshData
            );

            localStorage.removeItem("token");

            return Promise.reject("AUTH_EXPIRED");
        }

        // =====================================
        // SAVE NEW ACCESS TOKEN
        // =====================================
        token = refreshData.data.token;

        localStorage.setItem("token", token);

        console.log("Access token refreshed");

        // =====================================
        // RETRY ORIGINAL REQUEST
        // =====================================
        return fetch(url, {
            ...options,

            credentials: "include",

            headers: {
                ...(options.headers || {}),
                Authorization: `Bearer ${token}`
            }
        });
    };


    const rememberAuthReturnMode = () => {
        if (mode === MODES.CHECKOUT) {
            localStorage.setItem(AUTH_RETURN_MODE_KEY, MODES.CHECKOUT);
            return;
        }

        localStorage.setItem(AUTH_RETURN_MODE_KEY, MODES.ACCOUNT);
    };

    const goToPostAuthMode = async () => {
        const returnMode = localStorage.getItem(AUTH_RETURN_MODE_KEY);

        localStorage.removeItem(AUTH_RETURN_MODE_KEY);

        if (returnMode === MODES.CHECKOUT) {
            await fetchCart();
            await fetchUser();

            setMode(MODES.CHECKOUT);
            setIsRightOpen(true);
            setIsLeftOpen(false);
            setChevron(false);

            return;
        }

        setMode(MODES.ACCOUNT);
        setIsLeftOpen(true);
        setIsRightOpen(false);
        setChevron(false);
    };




    // refresh token and get user data on app load
    // refresh token and get user data on app load
    useEffect(() => {

        const init = async () => {

            try {

                // ===============================
                // USE authFetch INSTEAD OF fetch
                // ===============================
                const res = await authFetch(
                    `${baseURL}/users/me`,
                    {
                        method: "GET"
                    }
                );

                const data = await res.json();

                // ===============================
                // USER LOGGED IN
                // ===============================
                if (data.success) {

                    setCurrentUser(data.data);

                    // refresh server cart
                    await fetchCart();

                    return;
                }

                // ===============================
                // NOT LOGGED IN
                // ===============================
                setCurrentUser(null);

                const sessionRes = await fetch(
                    `${baseURL}/session/init`,
                    {
                        method: "GET",
                        credentials: "include"
                    }
                );

                const sessionData = await sessionRes.json();

                console.log("Session initialized:", sessionData);
                console.log("Session ID:", sessionData.sessionId);

            } catch (err) {

                console.error(err);

                setCurrentUser(null);

                try {

                    // ===============================
                    // FALLBACK GUEST SESSION
                    // ===============================
                    const sessionRes = await fetch(
                        `${baseURL}/session/init`,
                        {
                            method: "GET",
                            credentials: "include"
                        }
                    );

                    const sessionData = await sessionRes.json();

                    console.log(
                        "Fallback session initialized:",
                        sessionData
                    );

                    console.log(
                        "Fallback Session ID:",
                        sessionData.sessionId
                    );

                } catch (sessionErr) {

                    console.error(
                        "Session init failed:",
                        sessionErr
                    );
                }
            }
        };

        init();

    }, []);


    // wiping user fields
    useEffect(() => {

        // deletes login firlds when switching to signup page
        if (mode === MODES.SIGNUP) {
            setEmail("");
            setPassword("");
            setConfirmPassword("");
            setSignupError("");
            return;
        }

        // after sign in error dissapears
        if (mode === MODES.ACCOUNT || mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) {
            setLoginError("");
            setSignupError("");
            return;
        }
        // resets all address stuff when state chantes
        if (mode !== MODES.ACCOUNT || mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) {
            resetAccountUIState();
            setShowForgotPassword(false);
            setResetPassword("");
            setResetConfirmPassword("");
            setResetMessage("");
            setResetError("");
        }

        if (mode === !MODES.CHECKOUT) {
            setCheckoutError("");
            setPlacingOrder(false);
            return;
        }


    }, [mode]);

    // temp for toggling mobile
    useEffect(() => {
        // checks if mobile and changes colunm sizes available
        if (isMobile) {
            setColumnSize([2, 3]);
            // setColumnSize([3, 2, 1]);
            setColumnIndex(0);
        } else {
            setColumnSize([3, 5]);
            setColumnIndex(0);
        }

    }, [isMobile]);

    // switch to mobile view when window resizes below 768px
    useEffect(() => {
        const media = window.matchMedia("(max-width: 767px)");

        const handler = (e) => setIsMobile(e.matches);

        setIsMobile(media.matches);

        media.addEventListener("change", handler);

        return () => media.removeEventListener("change", handler);
    }, []);

    // handler because some sytem may have loaded befrore hand and miss the is mobile switch 
    const isMobileRef = useRef(isMobile);

    useEffect(() => {
        isMobileRef.current = isMobile;
    }, [isMobile]);

    // scans url for Google/Facebook call back and saves the credentials 

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);

        const token =
            params.get("auth_token") ||
            (window.location.pathname !== "/reset-password" ? params.get("token") : "");
        const authError = params.get("auth_error");

        if (authError) {
            setLoginError("Login failed. Please try again.");
            setToast("Login failed. Please try again.");
            setTimeout(() => setToast(null), 3500);
            setMode(MODES.ACCOUNT);
            setIsLeftOpen(true);

            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            );

            return;
        }

        // =====================================
        // ONLY ACCESS TOKEN IS ALLOWED
        // =====================================
        if (!token) return;

        // store access token only
        localStorage.setItem("token", token);

        // =====================================
        // CLEAN URL
        // =====================================
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        );

        // =====================================
        // INIT APP
        // =====================================
        const init = async () => {

            try {

                await fetchUser();

                await mergeGuestCart();

                await fetchCart();

                await goToPostAuthMode();

            } catch (err) {

                console.error("OAuth init failed", err);
            }
        };

        init();

    }, []);

    //  ############################################# NAVIGATION BUTTONS ####################################################

    // HANDELING THE CHEVRON TOGGLE
    const handleToggle = () => {
        if (mode === MODES.HOME) {
            cycleColumns();
            if (colunmSize.length === 2 && colunmIndex === 0 || colunmSize.length === 3 && colunmIndex === 1) {
                setChevron(false)
            } else (
                setChevron(true)
            )
            return;
        }

        if (mode === MODES.ITEM) {
            setIsRightOpen(false);
            setIsLeftOpen(false);
            setMode(MODES.HOME);
            updateChevron();
            return;
        }

        if (mode === MODES.ADDED || mode === MODES.CART) {
            setMode(MODES.ITEM);
            setIsRightOpen(true);
            setIsLeftOpen(true);
            return;
        }

        if (mode === MODES.CARTJUMP) {
            setMode(MODES.HOME);
            setIsRightOpen(false);
            setIsLeftOpen(false);
            updateChevron();
            return;
        }

        if (mode === MODES.ACCOUNT) {
            setMode(MODES.HOME);
            setIsRightOpen(false);
            setIsLeftOpen(false);
            updateChevron();
            return;
        }
        if (mode === MODES.SIGNUP) {
            setMode(MODES.ACCOUNT);
            setIsLeftOpen(true);
            setIsRightOpen(false);
            return;
        }
        if (mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) {
            setMode(MODES.CHECKOUT);
            setIsRightOpen(true);
            setIsLeftOpen(false);
            return;
        }
        if (mode === MODES.CHECKOUT) {
            setMode(MODES.CART);
            setIsRightOpen(true);
            setIsLeftOpen(true);
            return;
        }

    };

    const handleCartClick = async () => {

        const goingToCart =
            mode === MODES.HOME ||
            mode === MODES.ACCOUNT ||
            mode === MODES.ADD_ADDR ||
            mode === MODES.DEFAULT_ADDR ||
            mode === MODES.CHECKOUT ||
            mode === MODES.ITEM ||
            mode === MODES.ADDED;

        if (goingToCart && currentUser) {
            await fetchCart();
        }



        if (mode === MODES.HOME || mode === MODES.ACCOUNT || mode === MODES.ADD_ADDR || mode === MODES.DEFAULT_ADDR || mode === MODES.SIGNUP) {
            setMode(MODES.CARTJUMP);
            setIsRightOpen(true);
            setIsLeftOpen(false);
            return;
        }

        if (mode === MODES.ITEM || mode === MODES.ADDED) {
            setMode(MODES.CART);
            setIsRightOpen(true);
            setIsLeftOpen(false);
            return;
        }

        if (mode === MODES.CART || mode === MODES.CARTJUMP) {
            setMode(MODES.HOME);
            setIsRightOpen(false);
            setIsLeftOpen(false);
            updateChevron();
            return;
        }
        if (mode === MODES.CHECKOUT) {
            setMode(MODES.CART);
            setIsRightOpen(true);
            setIsLeftOpen(false);
            return;
        }
    };
    // FUTURE CASES (account, checkout, etc.)

    const handleAccClick = async () => {

        if (mode === MODES.ACCOUNT || mode === MODES.ADD_ADDR || mode === MODES.DEFAULT_ADDR || mode === MODES.SI) {
            setMode(MODES.HOME);
            setIsLeftOpen(false);
            setIsRightOpen(false);
            updateChevron();
            return;
        }

        if (mode === MODES.CHECKOUT && !currentUser) {
            rememberAuthReturnMode();
        }

        setMode(MODES.ACCOUNT);
        setIsLeftOpen(true);
        setIsRightOpen(false);
        setChevron(false);

        if (currentUser) {
            await fetchUser();
        }
    };

    const handleHomeClick = () => {
        if (mode === MODES.HOME) {
            showSiteAlert({
                title: "About Holy Threads",
                icon: "\u271d",
                type: "about",
                message: aboutHolyThreadsMessage
            });

            return;
        }

        setMode(MODES.HOME);
        setIsLeftOpen(false);
        setIsRightOpen(false);
        updateChevron();
    };

    // cycles through column sizes available based on if mobile or not
    const cycleColumns = () => {
        setColumnIndex((prev) => (prev + 1) % colunmSize.length);
    };

    // Going back to home and unsure if on smallest grid size
    const updateChevron = () => {

        if (colunmSize.length === 2 && colunmIndex === 1 || colunmSize.length === 3 && colunmIndex === 2) {
            setChevron(false);
        } else {
            setChevron(true);
        }
    };

    //  ############################################# Notifications #################################################################
    // hint to scroll 

    const [scrollHintCount, setScrollHintCount] = useState(0);
    const [scrollHintOpacity, setScrollHintOpacity] = useState(1);

    const scrollTimeout = useRef(null);
    const hintAutoDisableTimer = useRef(null);
    const hintDisabled = useRef(false);
    const wheelNavigationLocked = useRef(false);

    useEffect(() => {
        if (fullscreenImage) return;
        if (!isLeftOpen && !isRightOpen) return;

        const allowedModes = [MODES.ITEM, MODES.ADDED];
        if (!allowedModes.includes(mode)) return;

        const handleWheel = (e) => {

            setMode(MODES.ITEM);
            e.preventDefault();

            if (!clothes.length || wheelNavigationLocked.current) return;

            wheelNavigationLocked.current = true;
            setTimeout(() => {
                wheelNavigationLocked.current = false;
            }, 220);

            // ===============================
            // START AUTO DISABLE TIMER (ONLY ON FIRST INTERACTION)
            // ===============================
            if (!hintDisabled.current && !hintAutoDisableTimer.current) {

                hintAutoDisableTimer.current = setTimeout(() => {

                    hintDisabled.current = true;
                    setScrollHintOpacity(0);

                }, 4500); // Apple-like sweet spot (not too long, not annoying)

            }

            // ===============================
            // LEARNING / USAGE TRACKING
            // ===============================
            setScrollHintCount(prev => {

                const next = prev + 1;

                // user clearly understands → kill forever
                if (next >= 5) {

                    hintDisabled.current = true;
                    setScrollHintOpacity(0);

                    clearTimeout(hintAutoDisableTimer.current);

                }

                return next;
            });

            // ===============================
            // GRADUAL IDLE FADE (APPLE STYLE)
            // ===============================
            clearTimeout(scrollTimeout.current);

            scrollTimeout.current = setTimeout(() => {

                if (hintDisabled.current) return;

                setScrollHintOpacity(prev => {

                    if (prev <= 0) return 0;

                    const next = prev - 0.22;

                    return next <= 0 ? 0 : next;
                });

            }, 1200);

            // ===============================
            // ITEM CHANGE
            // ===============================
            triggerTitleFlash(e.deltaY > 0 ? "next" : "prev");

            setItemIndex((prev) => {

                if (e.deltaY > 0) {
                    return (prev + 1) % clothes.length;
                } else {
                    return (prev - 1 + clothes.length) % clothes.length;
                }

            });

        };

        window.addEventListener("wheel", handleWheel, { passive: false });

        return () => {

            window.removeEventListener("wheel", handleWheel);

            clearTimeout(scrollTimeout.current);
            clearTimeout(hintAutoDisableTimer.current);
        };

    }, [isLeftOpen, isRightOpen, mode, clothes.length]);
    //  ############################################# LOGIN #################################################################

    const login = async () => {
        if (loginInFlightRef.current) {
            return;
        }

        loginInFlightRef.current = true;
        setLoginSubmitting(true);

        try {
            setLoginError("");

            if (mode === MODES.CHECKOUT) {
                rememberAuthReturnMode();
            }

            const res = await fetch(`${baseURL}/users/login`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            });

            const data = await res.json();

            if (!data.success) {
                setLoginError(data.error || "Login failed");
                setToast(data.error || "Login failed");
                setTimeout(() => setToast(null), 3500);
                return;
            }
            // ✅ store token refresh is in cookies
            localStorage.setItem("token", data.data.token);

            // ===============================
            // STEP 4: Fetch user profile
            // ===============================
            await mergeGuestCart();
            await fetchUser();

            // ===============================
            // STEP 5: LOAD SERVER CART
            // ===============================
            await fetchCart();

            // ===============================
            // STEP 6 (OPTIONAL BUT IMPORTANT):
            // Merge guest cart into backend cart
            // ===============================
            resetAccountUIState();
            await goToPostAuthMode();
        } catch (err) {
            setLoginError("Something went wrong");
            setToast("Something went wrong");
            setTimeout(() => setToast(null), 3500);
        } finally {
            loginInFlightRef.current = false;
            setLoginSubmitting(false);
        }
    };

    const fetchUser = async () => {
        try {
            const res = await authFetch(`${baseURL}/users/me`);

            const data = await res.json();

            if (!res.ok || !data.success) {
                throw new Error("Failed to fetch user");
            }

            setCurrentUser(data.data);
            console.log(data.data);
        } catch (err) {
            console.error("User fetch failed:", err);
            setCurrentUser(null);
        }
    };

    const signUp = async (email, password) => {
        if (signupInFlightRef.current) {
            return;
        }

        signupInFlightRef.current = true;
        setSignupSubmitting(true);

        try {
            setSignupError("");

            if (password !== confirmPassword) {
                setSignupError("Passwords do not match");
                setToast("Passwords do not match");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            if (!passwordIsStrong) {
                setSignupError("Password does not meet all requirements");
                setToast("Password does not meet all requirements");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            const res = await fetch(`${baseURL}/users/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            });

            const data = await res.json();

            if (!data.success) {
                setSignupError(data.error || "Signup failed");
                setToast(data.error || "Signup failed");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            await login(email, password);

        } catch (err) {
            setSignupError("Server error");
            setToast("Server error");
            setTimeout(() => setToast(null), 3500);
        } finally {
            signupInFlightRef.current = false;
            setSignupSubmitting(false);
        }
    };
    const logout = async () => {
        try {
            // 1. Logout user session/token on backend
            await authFetch(`${baseURL}/users/logout`, {
                method: "POST"
            });

        } catch (err) {
            console.error("Logout request failed", err);
        }

        // 2. Clear frontend auth state
        localStorage.removeItem("token");
        setCurrentUser(null);

        try {
            // 3. Clear old guest/session cookie
            await fetch(`${baseURL}/session/reset`, {
                method: "POST",
                credentials: "include"
            });

            // 4. Create fresh guest session + empty cart
            await fetch(`${baseURL}/session/init`, {
                method: "GET",
                credentials: "include"
            });

            // 5. Fetch new empty guest cart
            await fetchCart();

        } catch (err) {
            console.error("Session reset failed", err);
            setCart([]);
        }

        setMode(MODES.HOME);
        setIsLeftOpen(false);
        setIsRightOpen(false);
    };

    const handleOAuthLogin = (provider) => {
        if (oauthInFlightRef.current) {
            return;
        }

        rememberAuthReturnMode();

        oauthInFlightRef.current = true;
        setOAuthSubmitting(provider);
        window.location.href = `${baseURL}/auth/${provider}`;
    };

    //  ############################################# PASSWORD REESET #######################################################
    // forgot
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");
    const [forgotPasswordError, setForgotPasswordError] = useState("");
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [forgotPasswordCooldown, setForgotPasswordCooldown] = useState(0);

    // reset
    const [resetToken, setResetToken] = useState("");
    const [resetPassword, setResetPassword] = useState("");
    const [resetConfirmPassword, setResetConfirmPassword] = useState("");
    const [resetMessage, setResetMessage] = useState("");
    const [resetError, setResetError] = useState("");

    useEffect(() => {
        if (forgotPasswordCooldown <= 0) {
            return;
        }

        const timer = setTimeout(() => {
            setForgotPasswordCooldown(prev => Math.max(prev - 1, 0));
        }, 1000);

        return () => clearTimeout(timer);
    }, [forgotPasswordCooldown]);

    const formatCooldownTime = (seconds) => {
        const safeSeconds = Math.max(0, seconds);
        const minutes = Math.floor(safeSeconds / 60);
        const remainingSeconds = safeSeconds % 60;

        return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
    };

    // forgot
    const requestPasswordReset = async () => {
        if (forgotPasswordInFlightRef.current || forgotPasswordCooldown > 0) {
            return;
        }

        forgotPasswordInFlightRef.current = true;
        setForgotPasswordSubmitting(true);

        try {
            setForgotPasswordError("");
            setForgotPasswordMessage("");

            if (!forgotPasswordEmail.trim()) {
                setForgotPasswordError("Email is required");
                return;
            }

            const res = await fetch(`${baseURL}/users/forgot-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: forgotPasswordEmail.trim()
                })
            });

            const data = await res.json();

            if (!res.ok || !data.success) {
                const retryAfter = Number(data.retryAfter);

                if (res.status === 429 && retryAfter > 0) {
                    setForgotPasswordCooldown(Math.ceil(retryAfter));
                }

                setForgotPasswordError(data.error || "Could not send reset email");
                return;
            }

            setForgotPasswordMessage(
                "If an account exists, a password reset link has been sent."
            );
            setForgotPasswordCooldown(60);

        } catch (err) {
            setForgotPasswordError("Network error. Try again.");
        } finally {
            forgotPasswordInFlightRef.current = false;
            setForgotPasswordSubmitting(false);
        }
    };

    // reset
    const submitNewPassword = async () => {
        if (resetPasswordInFlightRef.current) {
            return;
        }

        resetPasswordInFlightRef.current = true;
        setResetPasswordSubmitting(true);

        try {
            setResetError("");
            setResetMessage("");

            if (!resetPassword || !resetConfirmPassword) {
                setResetError("Both password fields are required");
                return;
            }

            if (resetPassword !== resetConfirmPassword) {
                setResetError("Passwords do not match");
                return;
            }

            const passwordRules = {
                length: resetPassword.length >= 8,
                upper: /[A-Z]/.test(resetPassword),
                lower: /[a-z]/.test(resetPassword),
                number: /[0-9]/.test(resetPassword),
                special: /[^A-Za-z0-9]/.test(resetPassword)
            };

            const isStrong = Object.values(passwordRules).every(Boolean);

            if (!isStrong) {
                setResetError("Password does not meet all requirements");
                return;
            }

            const res = await fetch(`${baseURL}/users/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: resetToken,
                    password: resetPassword
                })
            });

            const data = await res.json();

            if (!res.ok || !data.success) {
                setResetError(data.error || "Could not reset password");
                return;
            }

            setResetMessage("Password reset successfully. You can now log in.");
            setResetPassword("");
            setResetConfirmPassword("");

            window.history.replaceState(
                {},
                document.title,
                window.location.origin + window.location.pathname
            );

            setTimeout(() => {
                setResetToken("");
                setMode(MODES.ACCOUNT);
            }, 1500);

        } catch (err) {
            setResetError("Network error. Try again.");
        } finally {
            resetPasswordInFlightRef.current = false;
            setResetPasswordSubmitting(false);
        }
    };

    // useEFFECT to look for reset requsts 
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token =
            params.get("reset_token") ||
            (window.location.pathname === "/reset-password" ? params.get("token") : "");

        if (token) {
            setResetToken(token);
            setIsLeftOpen(true);
            setIsRightOpen(false);
            setMode(MODES.ACCOUNT);

            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            );
        }
    }, []);
    //  ############################################# ORDERS MANAGEMENT #######################################################
    const getOrderStatusLabel = (status) => {
        const labels = {
            pending: "Pending Payment",
            paid: "Paid",
            submitted_to_printful: "Processing",
            printful_draft: "Processing",
            printful_failed: "Processing Issue",
            shipped: "Shipped",
            cancelled: "Cancelled"
        };

        return labels[status] || status;
    };
    //  ############################################# BUYING MANAGEMENT #######################################################
    const [justAdded, setJustAdded] = useState(false);
    const [cartPulse, setCartPulse] = useState(false);
    const [pricePulse, setPricePulse] = useState(false);
    const pricePulseTimerRef = useRef(null);
    const previousDisplayedPriceRef = useRef(null);
    const [toast, setToast] = useState(null);

    const triggerPricePulse = useCallback(() => {
        if (pricePulseTimerRef.current) {
            clearTimeout(pricePulseTimerRef.current);
        }

        setPricePulse(false);

        requestAnimationFrame(() => {
            setPricePulse(true);
            pricePulseTimerRef.current = setTimeout(() => {
                setPricePulse(false);
            }, 1000);
        });
    }, []);

    const displayedPrice = selectedVariant
        ? `${selectedVariant.retail_price ?? ""}|${selectedVariant.currency ?? ""}`
        : null;

    useEffect(() => {
        if (!displayedPrice) return;

        if (previousDisplayedPriceRef.current === null) {
            previousDisplayedPriceRef.current = displayedPrice;
            return;
        }

        if (previousDisplayedPriceRef.current !== displayedPrice) {
            previousDisplayedPriceRef.current = displayedPrice;
            triggerPricePulse();
        }
    }, [displayedPrice, triggerPricePulse]);

    useEffect(() => {
        return () => {
            if (pricePulseTimerRef.current) {
                clearTimeout(pricePulseTimerRef.current);
            }
        };
    }, []);

    //  ############################################# CART MANAGEMENT #######################################################
    const [cart, setCart] = useState([]);

    // ===============================
    // FETCH CART FROM BACKEND
    // ===============================
    // const fetchCart = async () => {
    //     try {
    //         const res = await fetch(`${baseURL}/cart`, {
    //             method: "GET",
    //             credentials: "include"
    //         });

    //         const data = await res.json();

    //         if (data.success) {
    //             setCart(data.data.items || []);
    //             console.log("Fetched cart:", data.data.items);
    //         } else {
    //             console.error("Fetch cart failed:", data.error);
    //             setCart([]);
    //         }

    //     } catch (err) {
    //         console.error("Failed to fetch cart:", err);
    //     }
    // };
    const fetchCart = async () => {
        try {
            const res = await authFetch(`${baseURL}/cart`, {
                method: "GET"
            });

            const data = await res.json();

            if (data.success) {
                setCart(data.data.items || []);
                console.log("Fetched cart:", data.data.items);
            } else {
                console.error("Fetch cart failed:", data.error);
                setCart([]);
            }

        } catch (err) {
            console.error("Failed to fetch cart:", err);
            setCart([]);
        }
    };
    // ===============================
    // LOAD CART ON START
    // ===============================
    useEffect(() => {
        fetchCart();
    }, []);

    // ===============================
    // ADD TO CART
    // ===============================

    const addToCart = async (item) => {
        console.log("Adding to cart:", item);

        // ===============================
        // FEEDBACK SYSTEM
        // ===============================
        setJustAdded(true);
        setCartPulse(true);
        setToast("Add to Cart");

        setTimeout(() => setJustAdded(false), 1000);
        setTimeout(() => setCartPulse(false), 1000);
        setTimeout(() => setToast(null), 3500);

        try {
            const res = await authFetch(`${baseURL}/cart/add`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    variant_id: item.id,
                    quantity: 1
                })
            });

            const data = await res.json();

            if (!data.success) {
                console.error("Cart add failed:", data.error || data.message);
                setToast("Cart add failed:", data.error || data.message);
                setTimeout(() => setToast(null), 3500);
                return;
            }

            console.log("Cart add success:", data);

            await fetchCart();

        } catch (err) {
            console.error("Failed to add to cart:", err);
            setToast("Failed to add to cart:", err);
            setTimeout(() => setToast(null), 3500);
        }
    };


    // ===============================
    // INCREASE CART ITEM
    // ===============================
    const increaseCartItem = async (item) => {
        const newQty = item.quantity + 1;

        try {
            const res = await authFetch(`${baseURL}/cart/update`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    variant_id: item.variant_id,
                    quantity: newQty
                })
            });

            const data = await res.json();

            if (!data.success) {
                console.error("Cart update failed:", data.error);
                return;
            }

            await fetchCart();

        } catch (err) {
            console.error("Failed to update cart item:", err);
        }
    };

    // ===============================
    // REMOVE / DECREASE CART ITEM
    // ===============================
    const removeFromCart = async (item) => {
        const newQty = item.quantity - 1;

        try {
            if (newQty <= 0) {
                const res = await authFetch(`${baseURL}/cart/remove/${item.variant_id}`, {
                    method: "DELETE",
                    credentials: "include"
                });

                const data = await res.json();

                if (!data.success) {
                    console.error("Cart remove failed:", data.error);
                    return;
                }

                await fetchCart();
                return;
            }

            const res = await authFetch(`${baseURL}/cart/update`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    variant_id: item.variant_id,
                    quantity: newQty
                })
            });

            const data = await res.json();

            if (!data.success) {
                console.error("Cart update failed:", data.error);
                return;
            }

            await fetchCart();

        } catch (err) {
            console.error("Failed to remove cart item:", err);
        }
    };



    // ===============================
    // MERGE CARTS
    // ===============================
    const mergeGuestCart = async () => {
        try {
            const res = await authFetch(`${baseURL}/cart/merge-session`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });

            const data = await res.json();

            if (!data.success) {
                console.error("Merge failed:", data.error || data.message);
                return;
            }

            console.log("Merged guest cart:", data);

            await fetchCart();

        } catch (err) {
            console.error("Failed to merge guest cart:", err);
        }
    };

    // ===============================
    // HELPER FOR VARIANT IMAGE / PRODUCT DATA
    // ===============================
    const getVariantById = (variantId) => {
        for (const product of clothes) {
            const variant = product.variants?.find(v => v.id === variantId);

            if (variant) {
                return {
                    product,
                    variant
                };
            }
        }

        return null;
    };



    //  ############################################# LOAD CAROUSEL AND PRODUCTS ############################################

    // when variant color changes it reset the swiper index to 0
    useEffect(() => {
        swiperIndex.current?.slideTo(0);
    }, [selectedVariant?.color]);

    // API to fetch Products
    useEffect(() => {
        const fetchClothes = async () => {
            try {
                const res = await fetch(`${baseURL}/products`);
                const data = await res.json();
                setClothes(sortProductsForStore(data.data || []));
                // console.log("this is the data", data)
            } catch (err) {
                console.log(err);
            } finally {

            }
        };

        fetchClothes();


    }, []);

    /*
    Duplicate wheel handler removed. Item scrolling is handled by the
    notification wheel listener above so each wheel gesture advances once.

    // scroll wheel effect - changes clothes 
    useEffect(() => {
        return;
        if (!isLeftOpen && !isRightOpen) return;// Skips Below if Both Modals are closed 

        // skip if not in item or added mode
        const allowedModes = [MODES.ITEM, MODES.ADDED];

        if (!allowedModes.includes(mode)) return;

        const handleWheel = (e) => {
            setMode(MODES.ITEM);
            e.preventDefault();// stops scrolling


            setItemIndex((prev) => {// set the ItemIndex(clothes selected to move up or down)
                if (e.deltaY > 0) {
                    // scroll down → next item
                    return (prev + 1) % clothes.length;
                } else {
                    // scroll up → previous item
                    return (prev - 1 + clothes.length) % clothes.length;
                }
            });
        };

        window.addEventListener('wheel', handleWheel, { passive: false });// add event listener

        return () => window.removeEventListener('wheel', handleWheel);// terminates event listeners
    }, [isLeftOpen, isRightOpen, mode]);
    */

    // Helper - Updates selected variant - when clothes is loaded and itemIndex 
    useEffect(() => {
        if (!clothes.length || !itemSelected?.variants?.length) return;

        const defaultVariant =
            itemSelected.variants.find(v =>
                v.color?.toLowerCase() === "day"
            ) || itemSelected.variants[0];

        setSelectedVariant(defaultVariant);

    }, [itemIndex, clothes, itemSelected]);

    const getSizes = (product) => {
        return [...new Set(product.variants.map(v => v.size))];
    };

    const getColors = (product) => {
        return [...new Set(product.variants.map(v => v.color))];
    };

    const getHomeProductImage = (product) => {
        const primaryImage = product?.variants
            ?.flatMap(variant => variant.images || [])
            .find(image =>
                typeof image !== "string" &&
                Number(image.sort_order) === 0
            );

        return primaryImage?.url || product?.thumbnail_url;
    };

    // helper to get all images in carousel
    const getAllImages = (product, selectedColor) => {
        if (!product?.variants) return [];

        const variants = product.variants;

        // group images by color
        const grouped = variants.reduce((acc, variant) => {
            const color = variant.color;

            if (!acc[color]) acc[color] = [];

            const imgs = (variant.images || [])
                .filter(img =>
                    typeof img === "string" ||
                    Number(img.sort_order) !== 0
                )
                .map(img =>
                    typeof img === "string" ? img : img.url
                );

            acc[color].push(...imgs);

            return acc;
        }, {});

        // build final ordered list
        const selected = selectedColor ? grouped[selectedColor] || [] : [];

        const rest = Object.entries(grouped)
            .filter(([color]) => color !== selectedColor)
            .flatMap(([, imgs]) => imgs);

        return [...new Set([...selected, ...rest])];
    };

    //  ############################################# ADDRESS MANAGEMENT ########################################################

    const [addresses, setAddresses] = useState([]);
    const [editingAddress, setEditingAddress] = useState(null);
    const [showAddressBook, setShowAddressBook] = useState(false);
    const [showAddressForm, setShowAddressForm] = useState(false);
    const [showAddress, setShowAddress] = useState(false);
    const [addressError, setAddressError] = useState("");

    const [orders, setOrders] = useState([]);
    const [showOrders, setShowOrders] = useState(false);

    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [orderItemsMap, setOrderItemsMap] = useState({});

    const toggleOrder = async (orderId) => {
        const isOpen = expandedOrderId === orderId;

        if (isOpen) {
            setExpandedOrderId(null);
            return;
        }

        setExpandedOrderId(orderId);

        // only fetch if not already loaded
        if (!orderItemsMap[orderId]) {
            try {
                const res = await authFetch(`${baseURL}/orders/${orderId}`);
                const data = await res.json();

                if (data.success) {
                    console.log("Fetched order items for order", orderId, data.data.items);
                    setOrderItemsMap(prev => ({
                        ...prev,
                        [orderId]: data.data.items
                    }));
                }
            } catch (err) {
                console.error("Failed to load order items", err);
            }
        }
    };

    // resets all account states
    const resetAccountUIState = () => {
        setEditingAddress(null);
        setShowAddressBook(false);
        setShowAddressForm(false);
        setShowAddress(false);
        setAddressError("");
        setShowOrders(false);
        setShowOrders(false);
        setExpandedOrderId(null);

        setAddressForm({
            first_name: "",
            last_name: "",
            address_line1: "",
            address_line2: "",
            city: "",
            province: "",
            postal_code: "",
            country: "",
            country_code: "",
            state_code: "",
            is_default: true
        });
    };

    const [addressForm, setAddressForm] = useState({
        first_name: "",
        last_name: "",
        address_line1: "",
        address_line2: "",
        city: "",
        province: "",
        postal_code: "",
        country: "",
        country_code: "",
        state_code: "",
        is_default: true
    });

    const fetchAddresses = async () => {
        try {
            const res = await authFetch(`${baseURL}/addresses`);
            const data = await res.json();

            if (data.success) {
                setAddresses(data.data);
            }
        } catch (err) {
            console.error("Failed to fetch addresses:", err);
        }
    };

    // save/ update addresss
    const saveAddress = async () => {
        const url = editingAddress
            ? `${baseURL}/addresses/${editingAddress.id}`
            : `${baseURL}/addresses`;

        const method = editingAddress ? "PUT" : "POST";

        try {
            const res = await authFetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(addressForm)
            });

            const data = await res.json();

            if (!data.success) {
                setAddressError(data.error || "Something went wrong");
                setToast(data.error || "Something went wrong");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            setAddressError("");
            await refreshUser();

            if (mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) {
                resetAccountUIState();
                setMode(MODES.CHECKOUT);
                setIsLeftOpen(false);
                setIsRightOpen(true);
            }

            await fetchAddresses();
            setShowAddressForm(false);
            setEditingAddress(null);
            setShowAddress(true);

        } catch (err) {
            setAddressError("Network error. Try again.");
            setToast("Network error. Try again.");
            setTimeout(() => setToast(null), 3500);
        }
    };
    // delete addresss
    const deleteAddress = async (id) => {
        try {
            await authFetch(`${baseURL}/addresses/${id}`, {
                method: "DELETE"
            });

            await refreshUser();
            await fetchAddresses();
        } catch (err) {
            console.error("Failed to delete address:", err);
        }
    };

    // set default addresss
    const setDefault = async (id) => {
        try {
            await authFetch(`${baseURL}/addresses/${id}/set-default`, {
                method: "PUT"
            });

            await refreshUser();
        } catch (err) {
            console.error("Failed to set default address:", err);
        }
    };

    // refresh user data after address update to show new default address
    const refreshUser = async () => {
        try {
            const res = await authFetch(`${baseURL}/users/me`);
            const data = await res.json();

            if (data.success) {
                setCurrentUser(data.data);
            }
        } catch (err) {
            console.error("Failed to refresh user:", err);
        }
    };

    // for billing 
    // for billing

    const [sameBilling, setSameBilling] = useState(true);

    const [billingError, setBillingError] = useState("");

    const [billingForm, setBillingForm] = useState({
        first_name: "",
        last_name: "",
        address_line1: "",
        address_line2: "",
        city: "",
        province: "",
        state_code: "",
        postal_code: "",
        country: "",
        country_code: ""
    });

    const [guestShipping, setGuestShipping] = useState({
        first_name: "",
        last_name: "",
        address_line1: "",
        address_line2: "",
        city: "",
        province: "",
        state_code: "",
        postal_code: "",
        country: "",
        country_code: ""
    });

    const [shippingRates, setShippingRates] = useState([]);
    const [selectedShippingRate, setSelectedShippingRate] = useState(null);
    const [shippingLoading, setShippingLoading] = useState(false);
    const [shippingError, setShippingError] = useState("");

    const resetShippingSelection = () => {
        setShippingRates([]);
        setSelectedShippingRate(null);
        setShippingError("");
    };

    const updateGuestShipping = (field, value) => {
        setGuestShipping(prev => ({
            ...prev,
            [field]: value
        }));

        resetShippingSelection();
    };

    const updateBillingForm = (field, value) => {
        setBillingForm(prev => ({
            ...prev,
            [field]: value
        }));
    };


    const getShippingRecipient = () => {
        if (currentUser?.default_address) {
            return {
                address_line1: currentUser.default_address.address_line1,
                address_line2: currentUser.default_address.address_line2 || "",
                city: currentUser.default_address.city,
                state_code: currentUser.default_address.state_code || "",
                postal_code: currentUser.default_address.postal_code,
                country_code: currentUser.default_address.country_code || ""
            };
        }

        return {
            address_line1: guestShipping.address_line1,
            address_line2: guestShipping.address_line2,
            city: guestShipping.city,
            state_code: guestShipping.state_code,
            postal_code: guestShipping.postal_code,
            country_code: guestShipping.country_code
        };
    };

    const calculateShippingRates = async () => {
        setShippingError("");
        setShippingLoading(true);
        setSelectedShippingRate(null);

        try {
            const recipient = getShippingRecipient();

            const requestOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    recipient,
                    currency: "CAD"
                })
            };

            const res = currentUser
                ? await authFetch(`${baseURL}/printful/shipping-rates`, requestOptions)
                : await fetch(`${baseURL}/printful/shipping-rates`, requestOptions);

            const data = await res.json();

            if (!res.ok || !data.success) {
                throw new Error(data.error || "Could not calculate shipping");
            }

            setShippingRates(data.data || []);

            if (data.data?.[0]) {
                setSelectedShippingRate(data.data[0]);
            }

        } catch (err) {
            console.error("Shipping calculation error:", err);
            setShippingRates([]);
            setShippingError(err.message || "Shipping failed");
            setToast(err.message || "Shipping failed");
            setTimeout(() => setToast(null), 3500);

        } finally {
            setShippingLoading(false);
        }
    };

    // ############################################# PRINTFUL COUNTRY CODE ####################################################
    const [printfulCountries, setPrintfulCountries] = useState([]);
    const [countriesLoading, setCountriesLoading] = useState(false);
    const [countriesError, setCountriesError] = useState("");


    // fetch countries
    useEffect(() => {
        const fetchPrintfulCountries = async () => {
            setCountriesLoading(true);
            setCountriesError("");

            try {
                const res = await fetch(`${baseURL}/printful/countries`, {
                    method: "GET",
                    credentials: "include"
                });

                const data = await res.json();

                if (!res.ok || !data.success) {
                    throw new Error(data.error || "Could not load countries");
                }

                setPrintfulCountries(data.data || []);

            } catch (err) {
                console.error("Country list error:", err);
                setCountriesError(err.message || "Could not load countries");
            } finally {
                setCountriesLoading(false);
            }
        };

        fetchPrintfulCountries();
    }, []);

    const getCountryByCode = (countryCode) => {
        return printfulCountries.find(country =>
            country.code === countryCode
        );
    };

    const getStateOptions = (countryCode) => {
        return getCountryByCode(countryCode)?.states || [];
    };

    const updateAddressCountry = (setter, countryCode, shouldResetShipping = false) => {
        const country = getCountryByCode(countryCode);

        setter(prev => ({
            ...prev,
            country: country?.name || "",
            country_code: country?.code || "",
            province: "",
            state_code: ""
        }));

        if (shouldResetShipping) {
            resetShippingSelection();
        }
    };

    const updateAddressState = (
        setter,
        countryCode,
        stateCode,
        shouldResetShipping = false
    ) => {
        const state = getStateOptions(countryCode).find(s =>
            s.code === stateCode
        );

        setter(prev => ({
            ...prev,
            province: state?.name || "",
            state_code: state?.code || ""
        }));

        if (shouldResetShipping) {
            resetShippingSelection();
        }
    };

    const CountrySelect = ({ value, onChange }) => {
        return (
            <select
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                disabled={countriesLoading}
            >
                <option value="">
                    {countriesLoading ? "Loading countries..." : "Select Country"}
                </option>

                {printfulCountries.map(country => (
                    <option
                        key={country.code}
                        value={country.code}
                    >
                        {country.name}
                    </option>
                ))}
            </select>
        );
    };

    const StateSelect = ({ countryCode, value, onChange }) => {
        const states = getStateOptions(countryCode);

        if (!countryCode) {
            return (
                <select disabled value="">
                    <option>Select country first</option>
                </select>
            );
        }

        if (states.length === 0) {
            return null;
        }

        return (
            <select
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Select Province / State</option>

                {states.map(state => (
                    <option
                        key={state.code}
                        value={state.code}
                    >
                        {state.name}
                    </option>
                ))}
            </select>
        );
    };
    // ############################################# ABOUT SIGHT/ SUCCESS MANAGEMENT ####################################################

    const defaultSiteAlert = useMemo(() => ({
        title: "Success",
        icon: "\u2713",
        message: "",
        type: "success"
    }), []);

    const aboutHolyThreadsMessage = `Holy Threads is a Christian streetwear brand created to carry faith into everyday life.

    We strive to spread the word through faith based clothing, through inspired  biblical imagery, and references to scripture, while also providing quality fashion, creative visual appeal, and comfort. You're not only dressing your temple, you're clothing your spirit too.

Our mission is simple: Dress thy Body, Dress thy Soul.


Contact us: holythreads.support@gmail.com
`;

    const [siteAlert, setSiteAlert] = useState(defaultSiteAlert);

    const orderMessage = siteAlert.message;
    const renderAlertMessage = (message) => {
        const email = "holythreads.support@gmail.com";

        if (!message.includes(email)) {
            return message;
        }

        const [beforeEmail, afterEmail] = message.split(email);

        return (
            <>
                {beforeEmail}
                <a
                    href={`mailto:${email}`}
                    className="alert-email-link"
                    onClick={(e) => e.stopPropagation()}
                >
                    {email}
                </a>
                {afterEmail}
            </>
        );
    };
    const showSiteAlert = useCallback(({
        title = "Success",
        icon = "\u2713",
        message,
        type = "success"
    }) => {
        setSiteAlert({
            title,
            icon,
            message,
            type
        });
    }, []);

    const dismissOrderMessage = useCallback(() => {
        setSiteAlert(defaultSiteAlert);
    }, [defaultSiteAlert]);

    const [placingOrder, setPlacingOrder] = useState(false);
    const [checkoutError, setCheckoutError] = useState("");
    const [returnPolicyAccepted, setReturnPolicyAccepted] = useState(false);
    // return policy stuff
    const RETURN_POLICY_VERSION = "2026-07-03";

    const ReturnPolicyAgreement = ({
        accepted,
        onChange
    }) => {
        return (
            <section
                className="return-policy-card account-card no-flex"
                aria-labelledby="return-policy-title"
            >
                <h4 id="return-policy-title">
                    Return Policy
                </h4>

                <p>
                    Returns or exchanges
                    are not accepted for incorrect size, colour selection, or
                    change of mind.
                </p>

                <p>
                    If your item arrives damaged, defective, misprinted, or
                    incorrect, contact us within 30 days of delivery with your
                    order number and clear photos. Approved claims may receive a
                    replacement or refund.
                </p>

                <label
                    className="return-policy-checkbox"
                    htmlFor="return-policy-accepted"
                >
                    <input
                        id="return-policy-accepted"
                        type="checkbox"
                        checked={accepted}
                        onChange={(e) => onChange(e.target.checked)}
                    />

                    <span>
                        I have read and accept the return policy.
                    </span>
                </label>
            </section>
        );
    };
    const checkout = async () => {
        setCheckoutError("");
        dismissOrderMessage();

        if (!returnPolicyAccepted) {
            const message =
                "Please read and accept the made-to-order return policy.";

            setCheckoutError(message);
            setToast(message);
            setTimeout(() => setToast(null), 3500);

            return;
        }

        setPlacingOrder(true);

        try {
            if (!selectedShippingRate) {
                setCheckoutError("Please calculate and select a shipping option");
                setPlacingOrder(false);

                setToast("Please calculate and select a shipping option");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            const payload = {
                selected_shipping_rate: selectedShippingRate,
                return_policy_accepted: returnPolicyAccepted,
                return_policy_version: RETURN_POLICY_VERSION
            };

            // ===============================
            // LOGGED IN USER
            // ===============================
            if (currentUser) {
                const shippingId = currentUser?.default_address?.id;

                if (!shippingId) {
                    setCheckoutError("Please add a default shipping address");
                    setPlacingOrder(false);
                    setToast("Please add a default shipping address");
                    setTimeout(() => setToast(null), 3500);
                    return;
                }

                payload.shipping_address_id = shippingId;

                if (sameBilling) {
                    payload.billing_address_id = shippingId;
                } else {
                    payload.billing_address_id = null;
                    payload.billing_address = billingForm;
                }
            }

            // ===============================
            // GUEST USER
            // ===============================
            else {
                if (!email.trim()) {
                    setCheckoutError("Email is required");
                    setPlacingOrder(false);

                    setToast("Email is required");
                    setTimeout(() => setToast(null), 3500);
                    return;
                }

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailRegex.test(email.trim())) {
                    setCheckoutError("Invalid email address");
                    setPlacingOrder(false);

                    setToast("Invalid email address");
                    setTimeout(() => setToast(null), 3500);
                    return;
                }

                payload.guest_email = email.trim();
                payload.shipping_address_id = null;
                payload.shipping_form = guestShipping;

                if (sameBilling) {
                    payload.billing_address = guestShipping;
                } else {
                    payload.billing_address = billingForm;
                }
            }

            const res = currentUser
                ? await authFetch(`${baseURL}/orders/create`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                })
                : await fetch(`${baseURL}/orders/create`, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });

            const data = await res.json();

            if (!res.ok || !data.success) {
                setCheckoutError(data.error || data.message || "Checkout failed");
                setPlacingOrder(false);
                setToast(data.error || data.message || "Checkout failed");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            const publicOrderNumber =
                data.data?.public_order_number ||
                "your order";

            showSiteAlert({
                title: "Order Created",
                icon: "\u2713",
                type: "success",
                message: `Order #${publicOrderNumber} created. Redirecting to payment...`
            });

            const stripeOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    order_id: data.data.id
                })
            };

            const stripeRes = currentUser
                ? await authFetch(`${baseURL}/stripe/create-checkout-session`, stripeOptions)
                : await fetch(`${baseURL}/stripe/create-checkout-session`, stripeOptions);

            const stripeData = await stripeRes.json();

            if (!stripeRes.ok || !stripeData.success) {
                setCheckoutError(stripeData.error || "Stripe checkout failed");
                dismissOrderMessage();
                setPlacingOrder(false);

                setToast(stripeData.error || "Stripe checkout failed");
                setTimeout(() => setToast(null), 3500);
                return;
            }

            window.location.href = stripeData.url;

        } catch (err) {
            console.error("Checkout error:", err);
            setCheckoutError("Network error");

            setToast("Network error");
            setTimeout(() => setToast(null), 3500);
            setPlacingOrder(false);
        }
    };

    // stripe returns to this page with payment status in query params, we need to confirm the payment and show success / error message accordingly
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const paymentStatus = params.get("payment");
        const orderId = params.get("order_id");
        const stripeSessionId = params.get("session_id");

        const clearPaymentParams = () => {
            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            );
        };

        if (paymentStatus === "cancelled") {
            setCheckoutError("Payment was cancelled.");
            dismissOrderMessage();

            setPlacingOrder(false);
            setMode(MODES.CHECKOUT);
            clearPaymentParams();
            return;
        }

        if (paymentStatus !== "success") {
            return;
        }

        const confirmStripePayment = async () => {
            if (!orderId || !stripeSessionId) {
                setCheckoutError("Payment returned without a checkout session.");
                return;
            }

            setPlacingOrder(true);
            setCheckoutError("");
            showSiteAlert({
                title: "Confirming Payment",
                icon: "\u2713",
                type: "success",
                message: "Confirming your payment..."
            });

            try {
                const res = await fetch(`${baseURL}/stripe/confirm-checkout-session`, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        order_id: orderId,
                        session_id: stripeSessionId
                    })
                });

                const data = await res.json();

                if (!res.ok || !data.success) {
                    throw new Error(data.error || "Payment confirmation failed");
                }

                await fetchCart();

                setCheckoutError("");

                const publicOrderNumber =
                    data.data?.public_order_number ||
                    data.data?.order?.public_order_number ||
                    "your order";

                showSiteAlert({
                    title: "Success",
                    icon: "\u2713",
                    type: "success",
                    message: `Order #${publicOrderNumber} placed successfully. Updates will be sent to your E-mail shortly.`
                });

                setIsRightOpen(false);

                setIsLeftOpen(true);

                setMode(MODES.ACCOUNT);

                if (localStorage.getItem("token")) {
                    await fetchUser();
                }

                clearPaymentParams();
            } catch (err) {
                console.error("Stripe confirmation error:", err);
                dismissOrderMessage();
                setCheckoutError(
                    "Payment succeeded, but the order could not be confirmed yet. Refresh this page to retry."
                );
            } finally {
                setPlacingOrder(false);
            }
        };

        confirmStripePayment();

    }, [dismissOrderMessage, showSiteAlert]);

    //  ############################################# PRODUCT RENDERING #####################################################

    // for direction of waves
    const [titleFlashDirection, setTitleFlashDirection] = useState("next");

    // render clothes on home page
    const getHomeLayout = () => {
        const columns = colunmSize[colunmIndex];

        // DESKTOP
        if (!isMobile) {
            if (columns === 5) {
                return {
                    columns: 6,
                    rows: 2,
                    itemsPerPage: 12
                };
            }

            if (columns === 3) {
                return {
                    columns: 3,
                    rows: 2,
                    itemsPerPage: 6
                };
            }
        }

        // MOBILE
        if (isMobile) {
            if (columns === 3) {
                return {
                    columns: 3,
                    rows: 4,
                    itemsPerPage: 12
                };
            }

            if (columns === 2) {
                return {
                    columns: 2,
                    rows: 3,
                    itemsPerPage: 6
                };
            }

            if (columns === 1) {
                return {
                    columns: 1,
                    rows: 1,
                    itemsPerPage: 1
                };
            }
        }

        return {
            columns,
            rows: 2,
            itemsPerPage: columns * 2
        };
    };

    const sortProductsForStore = (products = []) => {
        const normalizeName = (name) =>
            name?.trim().toLowerCase();

        const pinnedToEnd = [
            "roses",
            "crosses",
            "aurora",
            "starry supper",
            "protection",
            "anoint"
        ];

        return [...products]
            .map((product, originalIndex) => {
                const pinnedIndex = pinnedToEnd.indexOf(
                    normalizeName(product.name)
                );

                return {
                    product,
                    originalIndex,
                    pinnedIndex
                };
            })
            .sort((a, b) => {
                const aIsPinned = a.pinnedIndex !== -1;
                const bIsPinned = b.pinnedIndex !== -1;

                if (aIsPinned !== bIsPinned) {
                    return aIsPinned ? 1 : -1;
                }

                if (aIsPinned && bIsPinned) {
                    return a.pinnedIndex - b.pinnedIndex;
                }

                return a.originalIndex - b.originalIndex;
            })
            .map(({ product }) => product);
    };
    const homeProducts = useMemo(() => {
        return clothes;
    }, [clothes]);
    const getHomePages = () => {
        const { itemsPerPage } = getHomeLayout();

        return chunkArray(homeProducts, itemsPerPage);
    };

    const renderHomePage = (pageItems, pageIndex) => {
        const { columns } = getHomeLayout();

        return (
            <table className={`clothes-table home-page-table cols-${columns}`}>
                <tbody>
                    {chunkArray(pageItems, columns).map((row, rowIndex) => (
                        <tr key={`${pageIndex}-${rowIndex}`}>
                            {row.map((item) => (
                                <td key={item.id}>
                                    <img
                                        className="card product-main-image"
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        src={getHomeProductImage(item)}
                                        onClick={() => handleSelectItem(item.id)}
                                        onError={(e) => {
                                            console.error("PRODUCT IMAGE FAILED:", e.currentTarget.src);
                                        }}
                                        loading="lazy"
                                        decoding="async"
                                        alt={item.name}
                                    />

                                    <p>{item.name}</p>

                                    <p>
                                        ${item.variants?.[0]?.retail_price || "—"}
                                    </p>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const handleSelectItem = (productId) => {
        clearTitleFlash();

        const realIndex = clothes.findIndex(
            product => product.id === productId
        );

        if (realIndex === -1) return;

        setItemIndex(realIndex);

        if (!isMobile) {
            setIsLeftOpen(true);
        }

        setIsRightOpen(true);
        setMode(MODES.ITEM);
        setChevron(false);
    };
    // Helper render clothes - Changes Array of Apparel Data into smaller chunks based on the number of colunms
    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };


    //  ############################################# Swipping #####################################################
    const SWIPE_THRESHOLD = 60;
    const SWIPE_TIME = 700;
    const touchStart = useRef({
        x: 0,
        y: 0,
        time: 0,
        leftAtTopOnStart: false,
        leftAtBottomOnStart: false,
        rightAtTopOnStart: false,
        rightAtBottomOnStart: false,
        startedOnProductSwiper: false
    });

    const gestureLockedRef = useRef(false);

    const PANEL_EDGE_BUFFER = 6;
    const GESTURE_LOCK_MS = 280;

    // MODES THAT BLOCK GESTURES
    const GESTURE_DISABLED_MODES = new Set([
        // MODES.ITEM,
    ]);

    const gesturesEnabled =
        !GESTURE_DISABLED_MODES.has(mode) &&
        !fullscreenImage;

    // TOUCH ZONE (20% margin)
    const isInTouchZone = (x, y) => {
        const w = window.innerWidth;
        const h = window.innerHeight;

        const left = w * 0.05;
        const right = w * 0.95;
        const top = h * 0.05;
        const bottom = h * 0.95;

        return x >= left && x <= right && y >= top && y <= bottom;
    };

    const getPanelEdgeState = (panel) => {
        if (!panel) {
            return {
                atTop: true,
                atBottom: true
            };
        }

        const maxScrollTop = Math.max(
            0,
            panel.scrollHeight - panel.clientHeight
        );

        const scrollTop = Math.max(
            0,
            panel.scrollTop || 0
        );

        return {
            atTop: scrollTop <= PANEL_EDGE_BUFFER,
            atBottom: maxScrollTop - scrollTop <= PANEL_EDGE_BUFFER
        };
    };

    const lockGestureBriefly = () => {
        if (gestureLockedRef.current) return false;

        gestureLockedRef.current = true;

        setTimeout(() => {
            gestureLockedRef.current = false;
        }, GESTURE_LOCK_MS);

        return true;
    };

    const closePanelsToHome = () => {
        setIsRightOpen(false);
        setIsLeftOpen(false);
        setMode(MODES.HOME);
        updateChevron();
    };


    // Detect double swipe up and turn off gestures
    const swipeDownArmedRef = useRef(false);
    const swipeDownTimerRef = useRef(null);

    const DOUBLE_SWIPE_WINDOW = 450;

    const [isRefreshing, setIsRefreshing] = useState(false);



    const DIRECTION_LOCK_RATIO = 1.4;

    const getGesture = (dx, dy, dt) => {

        if (dt > SWIPE_TIME) return "NONE";

        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        // not enough movement
        if (
            absX < SWIPE_THRESHOLD &&
            absY < SWIPE_THRESHOLD
        ) {
            return "NONE";
        }

        // =========================
        // VERTICAL SWIPES
        // =========================
        if (absY > absX * DIRECTION_LOCK_RATIO) {

            if (dy > SWIPE_THRESHOLD) {
                return "SWIPE_DOWN";
            }

            if (dy < -SWIPE_THRESHOLD) {
                return "SWIPE_UP";
            }
        }

        // =========================
        // HORIZONTAL SWIPES
        // =========================
        if (absX > absY * DIRECTION_LOCK_RATIO) {

            if (dx > SWIPE_THRESHOLD) {
                return "SWIPE_RIGHT";
            }

            if (dx < -SWIPE_THRESHOLD) {
                return "SWIPE_LEFT";
            }
        }

        return "NONE";
    };

    // // STATE MACHINE
    const transition = (gesture, start = touchStart.current) => {

        const leftStartedAtTop = Boolean(start?.leftAtTopOnStart);
        const leftStartedAtBottom = Boolean(start?.leftAtBottomOnStart);
        const rightStartedAtTop = Boolean(start?.rightAtTopOnStart);

        // =====================================================
        // GLOBAL: DESKTOP / TABLET DOUBLE SWIPE DOWN REFRESH
        // =====================================================
        if (!isMobileRef.current && gesture === "SWIPE_DOWN") {

            // -------------------------------------------------
            // Determine "top" based on active scroll context
            // -------------------------------------------------
            const startedAtTop =
                (isLeftOpen && leftStartedAtTop) ||
                (isRightOpen && rightStartedAtTop) ||
                (!isLeftOpen && !isRightOpen && window.scrollY <= 5);

            // ❌ If not at top, cancel any armed swipe
            if (!startedAtTop) {
                swipeDownArmedRef.current = false;
                clearTimeout(swipeDownTimerRef.current);
                return;
            }

            // =========================
            // FIRST SWIPE → ARM
            // =========================
            if (!swipeDownArmedRef.current) {

                swipeDownArmedRef.current = true;

                clearTimeout(swipeDownTimerRef.current);

                swipeDownTimerRef.current = setTimeout(() => {
                    swipeDownArmedRef.current = false;
                }, DOUBLE_SWIPE_WINDOW);

                console.log("Desktop swipe armed (1/2)");
                return;
            }

            // =========================
            // SECOND SWIPE → REFRESH
            // =========================
            swipeDownArmedRef.current = false;
            clearTimeout(swipeDownTimerRef.current);

            console.log("Desktop refresh triggered");

            setIsRefreshing(true);

            setTimeout(() => {
                window.location.reload();
            }, 600);

            return;
        }

        switch (mode) {

            case MODES.HOME:
                if (isMobileRef.current) {

                    if (gesture === "SWIPE_DOWN") {
                        setIsRightOpen(false);
                        setIsLeftOpen(true);
                        setMode(MODES.ACCOUNT);
                        setChevron(false);
                    }

                    if (gesture === "SWIPE_UP") {
                        setIsLeftOpen(false);
                        setIsRightOpen(true);
                        setMode(MODES.CARTJUMP);
                        setChevron(false);
                    }
                }

                if (!isMobileRef.current) {
                    if (gesture === "SWIPE_RIGHT") {
                        setIsRightOpen(false);
                        setIsLeftOpen(true);
                        setMode(MODES.ACCOUNT);
                        setChevron(false);
                    }

                    if (gesture === "SWIPE_LEFT") {
                        setIsLeftOpen(false);
                        setIsRightOpen(true);
                        setMode(MODES.CARTJUMP);
                        setChevron(false);
                    }
                    return;
                }

                break;

            case MODES.SIGNUP:
            case MODES.ACCOUNT:
            case MODES.DEFAULT_ADDR:
            case MODES.ADD_ADDR:
                if (isMobileRef.current) {
                    if (gesture === "SWIPE_UP") {

                        // Close account panel only if the swipe started at the bottom.
                        if (leftStartedAtBottom) {
                            closePanelsToHome();
                        }

                        return;
                    }

                    if (gesture === "SWIPE_DOWN") {

                        // Only allow double swipe refresh if the swipe started at top.
                        if (!leftStartedAtTop) {
                            swipeDownArmedRef.current = false;
                            clearTimeout(swipeDownTimerRef.current);
                            return;
                        }

                        // =========================
                        // FIRST SWIPE DOWN → ARM
                        // =========================
                        if (!swipeDownArmedRef.current) {

                            swipeDownArmedRef.current = true;

                            clearTimeout(swipeDownTimerRef.current);

                            swipeDownTimerRef.current = setTimeout(() => {
                                swipeDownArmedRef.current = false;
                            }, DOUBLE_SWIPE_WINDOW);

                            console.log("Swipe down armed (1/2)");

                            return;
                        }

                        // =========================
                        // SECOND SWIPE DOWN → REFRESH
                        // =========================
                        swipeDownArmedRef.current = false;
                        clearTimeout(swipeDownTimerRef.current);

                        console.log("Swipe refresh triggered");

                        // show UI first
                        setIsRefreshing(true);

                        setTimeout(() => {
                            window.location.reload();
                        }, 600);

                        return;
                    }
                }

                if (!isMobileRef.current) {
                    if (gesture === "SWIPE_LEFT") {

                        // Desktop account panel closes only if the swipe started at top.
                        if (leftStartedAtTop) {
                            closePanelsToHome();
                        }

                        return;
                    }
                }
                break;


            case MODES.CHECKOUT:
            case MODES.CART:
            case MODES.CARTJUMP:
                if (isMobileRef.current) {
                    if (gesture === "SWIPE_DOWN") {

                        // Close right panel only if the swipe started at the top.
                        if (rightStartedAtTop) {
                            closePanelsToHome();
                        }

                        return;
                    }
                    if (gesture === "SWIPE_RIGHT" || gesture === "SWIPE_LEFT") {
                        if (mode === MODES.CARTJUMP && !rightStartedAtTop) {
                            return;
                        }

                        handleToggle();
                        return;
                    }

                }
                if (!isMobileRef.current) {
                    if (gesture === "SWIPE_RIGHT") {
                        if (mode === MODES.CARTJUMP) {
                            if (rightStartedAtTop) {
                                closePanelsToHome();
                            }

                            return;
                        }

                        handleToggle();
                        return;
                    }

                    if (gesture === "SWIPE_LEFT") {
                        handleToggle();
                        return;
                    }

                }

                break;

            case MODES.ADDED:
            case MODES.ITEM:
                if (isMobileRef.current) {
                    if (gesture === "SWIPE_LEFT") {
                        changeItemBySwipe("next");
                        return;
                    }

                    if (gesture === "SWIPE_RIGHT") {
                        changeItemBySwipe("prev");
                        return;
                    }

                    if (gesture === "SWIPE_DOWN") {
                        // Close product panel only if the swipe started at the top.
                        if (rightStartedAtTop) {
                            closePanelsToHome();
                        }

                        return;
                    }
                }

                if (!isMobileRef.current) {
                    if (gesture === "SWIPE_RIGHT" || gesture === "SWIPE_LEFT") {
                        if (rightStartedAtTop) {
                            closePanelsToHome();
                        }

                        return;
                    }
                }

                break;


            default:
                break;
        }
    };


    // Detect Gesters EFFECT
    useEffect(() => {
        if (!gesturesEnabled) return;
        const onTouchStart = (e) => {
            const touch = e.touches?.[0];
            if (!touch) return;

            if (!isInTouchZone(touch.clientX, touch.clientY)) return;

            const leftEdges = getPanelEdgeState(leftPanelRef.current);
            const rightEdges = getPanelEdgeState(rightPanelRef.current);

            touchStart.current = {
                x: touch.clientX,
                y: touch.clientY,
                time: performance.now(),

                leftAtTopOnStart: leftEdges.atTop,
                leftAtBottomOnStart: leftEdges.atBottom,

                rightAtTopOnStart: rightEdges.atTop,
                rightAtBottomOnStart: rightEdges.atBottom,

                startedOnProductSwiper:
                    (mode === MODES.ITEM || mode === MODES.ADDED) &&
                    !!e.target.closest(".item-preview .swiper")
            };
        };
        const onTouchEnd = (e) => {
            if (!gesturesEnabled) return;

            const touch = e.changedTouches?.[0];
            if (!touch) return;

            const start = touchStart.current;
            if (!start.time) return;

            const dx = touch.clientX - start.x;
            const dy = touch.clientY - start.y;
            const dt = performance.now() - start.time;

            const gesture = getGesture(dx, dy, dt);

            const isLeftRightSwipe =
                gesture === "SWIPE_LEFT" ||
                gesture === "SWIPE_RIGHT";

            // mobile only:
            // if swipe started on product swiper,
            // kill left/right but allow up/down
            if (start.startedOnProductSwiper && isLeftRightSwipe) {
                touchStart.current = { x: 0, y: 0, time: 0 };
                return;
            }

            if (gesture !== "NONE") {
                if (!lockGestureBriefly()) {
                    touchStart.current = { x: 0, y: 0, time: 0 };
                    return;
                }

                transition(gesture, start);
            }

            // reset after every gesture cycle
            touchStart.current = { x: 0, y: 0, time: 0 };
        };

        window.addEventListener("touchstart", onTouchStart, { passive: true });
        window.addEventListener("touchend", onTouchEnd, { passive: true });

        return () => {
            window.removeEventListener("touchstart", onTouchStart);
            window.removeEventListener("touchend", onTouchEnd);
        };
    }, [gesturesEnabled, mode, fullscreenImage]);

    const productCarouselKey = `${itemSelected?.id || "no-item"}-${selectedVariant?.color || "no-color"}`;

    const resetProductCarousel = () => {
        const swiper = swiperIndex.current;

        if (!swiper || swiper.destroyed) return;

        swiper.update?.();

        if (typeof swiper.slideToLoop === "function") {
            swiper.slideToLoop(0, 0, false);
            return;
        }

        swiper.slideTo(0, 0, false);
    };

    useEffect(() => {
        if (mode !== MODES.ITEM && mode !== MODES.ADDED) return;

        requestAnimationFrame(() => {
            resetProductCarousel();
        });
    }, [itemSelected?.id, selectedVariant?.color, mode]);

    // when mobile and changes item by swipe
    const changeItemBySwipe = (direction) => {
        if (!clothes.length) return;

        setMode(MODES.ITEM);
        triggerTitleFlash(direction);

        setItemIndex((prev) => {
            if (direction === "next") {
                return (prev + 1) % clothes.length;
            }

            return (prev - 1 + clothes.length) % clothes.length;
        });
    };

    // helper when sensing when not on siper so can change item 
    const isInsideSwiper = (target) => {
        return target.closest(".swiper");
    };

    // reference point, only closes when at the top/bottom of the panel y-axis
    const rightPanelRef = useRef(null);
    const leftPanelRef = useRef(null);

    //  ############################################# PRODUCT INFO FLASH ###################################################


    const [showTitleFlash, setShowTitleFlash] = useState(false);
    const [titleFlashKey, setTitleFlashKey] = useState(0);

    const titleFlashTimerRef = useRef(null);
    const titleFlashImageRef = useRef(null);

    useEffect(() => {
        const preloadLink = document.createElement("link");
        preloadLink.rel = "preload";
        preloadLink.as = "image";
        preloadLink.href = waveImg;
        document.head.appendChild(preloadLink);

        const img = new Image();
        img.decoding = "async";
        img.loading = "eager";
        img.src = waveImg;
        if (typeof img.decode === "function") {
            img.decode().catch(() => { });
        }
        titleFlashImageRef.current = img;

        return () => {
            preloadLink.remove();
            titleFlashImageRef.current = null;
        };
    }, []);

    const clearTitleFlash = () => {
        clearTimeout(titleFlashTimerRef.current);
        setShowTitleFlash(false);
    };

    const triggerTitleFlash = (direction = "next") => {
        clearTimeout(titleFlashTimerRef.current);

        setTitleFlashDirection(direction);
        setTitleFlashKey(prev => prev + 1);
        setShowTitleFlash(true);

        titleFlashTimerRef.current = setTimeout(() => {
            setShowTitleFlash(false);
        }, 650);
    };

    useEffect(() => {
        return () => clearTimeout(titleFlashTimerRef.current);
    }, []);

    const leftPanel = () => {
        return (
            <div className="left-panel-content">

                {resetToken && (
                    <div className="account-section">
                        {isMobile ? (
                            <div className="space-gap" />
                        ) : (
                            <div className="space-gap-mini" />
                        )}

                        {/* =============================== RESET PASSWORD SECTION =============================== */}
                        <div className="menu">
                            <h2>Reset Password</h2>

                            {resetError && (
                                <p className="error">{resetError}</p>
                            )}

                            {resetMessage && (
                                <p>{resetMessage}</p>
                            )}

                            <PasswordField
                                id="reset-new-password"
                                name="new-password"
                                autoComplete="new-password"
                                placeholder="New Password"
                                value={resetPassword}
                                onChange={(e) => {
                                    setResetPassword(e.target.value);
                                    setResetError("");
                                    setResetMessage("");
                                }}
                            />

                            <PasswordField
                                id="reset-confirm-password"
                                name="confirm-new-password"
                                autoComplete="new-password"
                                placeholder="Confirm New Password"
                                value={resetConfirmPassword}
                                onChange={(e) => {
                                    setResetConfirmPassword(e.target.value);
                                    setResetError("");
                                    setResetMessage("");
                                }}
                            />
                            <button
                                type="button"
                                disabled={resetPasswordSubmitting}
                                onClick={animateThen(submitNewPassword)}
                            >
                                Reset Password
                            </button>

                            <button
                                type="button"
                                onClick={animateThen(() => {
                                    setResetToken("");
                                    setResetPassword("");
                                    setResetConfirmPassword("");
                                    setResetError("");
                                    setResetMessage("");
                                    setMode(MODES.ACCOUNT);
                                })}
                            >
                                Back to Login
                            </button>
                        </div>
                    </div>
                )}

                {/* =============================== ACCOUNT SECTION =============================== */}
                {!resetToken && (mode === MODES.ACCOUNT || mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) && (
                    <div>


                        <div className="account-section">
                            {isMobile ? (
                                <div className="space-gap" />
                            ) : (
                                <div className="space-gap-mini" />
                            )}

                            {currentUser ? (
                                <>
                                    {/* =============================== LOGGED IN =============================== */}
                                    <div className="menu">

                                        <div onClick={animateLongThen(handleToggle)}>
                                            <h2 className="glass-thick glass-header-title">
                                                My Account
                                            </h2>
                                        </div>

                                        <h3>Shipping Address</h3>

                                        <div>
                                            {currentUser.default_address ? (
                                                <div className="account-card">
                                                    <p>
                                                        <strong>
                                                            {currentUser.default_address.first_name}{" "}
                                                            {currentUser.default_address.last_name}
                                                        </strong>
                                                    </p>

                                                    <p>{currentUser.default_address.address_line1}</p>

                                                    {currentUser.default_address.address_line2 && (
                                                        <p>{currentUser.default_address.address_line2}</p>
                                                    )}

                                                    <p>
                                                        {currentUser.default_address.city},{" "}
                                                        {currentUser.default_address.province}
                                                    </p>

                                                    <p>
                                                        {currentUser.default_address.postal_code},{" "}
                                                        {currentUser.default_address.country}
                                                    </p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p>No address set</p>
                                                </div>
                                            )}
                                        </div>

                                        <button
                                            type="button"
                                            className={`address-btn ${showAddressBook ? "is-open" : ""}`}
                                            onClick={animateThen(() => {
                                                setShowAddressBook(prev => {
                                                    const next = !prev;

                                                    setShowAddress(next);

                                                    if (next) {
                                                        fetchAddresses();

                                                        if (!currentUser?.default_address) {
                                                            setShowAddressForm(true);
                                                            setEditingAddress(null);
                                                            setAddressError("");
                                                            setAddressForm({
                                                                first_name: "",
                                                                last_name: "",
                                                                address_line1: "",
                                                                address_line2: "",
                                                                city: "",
                                                                province: "",
                                                                postal_code: "",
                                                                country: "",
                                                                country_code: "",
                                                                state_code: "",
                                                                is_default: true
                                                            });
                                                        }
                                                    } else {
                                                        setShowAddressBook(false);
                                                        setShowAddressForm(false);
                                                        setAddressError("");
                                                        setEditingAddress(null);
                                                    }

                                                    return next;
                                                });
                                            })}
                                        >
                                            {currentUser.default_address ? "Change Address" : "Add Address"}
                                        </button>

                                        {/* ================= ADDRESS SECTION ================= */}
                                        <div className="address-section">

                                            {showAddressBook && (
                                                <div>
                                                    <h4>Addresss Book</h4>

                                                    {/* FORM */}
                                                    {showAddressForm && (
                                                        <div className="address-form">
                                                            {addressError && <p className="error">{addressError}</p>}

                                                            <div className="row">
                                                                <input
                                                                    type="text"
                                                                    name="given-name"
                                                                    autoComplete="given-name"
                                                                    placeholder="First Name"
                                                                    value={addressForm.first_name}
                                                                    onChange={e => {
                                                                        setAddressForm({
                                                                            ...addressForm,
                                                                            first_name: e.target.value
                                                                        });
                                                                        setAddressError("");
                                                                    }}
                                                                />

                                                                <input
                                                                    type="text"
                                                                    name="family-name"
                                                                    autoComplete="family-name"
                                                                    placeholder="Last Name"
                                                                    value={addressForm.last_name}
                                                                    onChange={e => {
                                                                        setAddressForm({
                                                                            ...addressForm,
                                                                            last_name: e.target.value
                                                                        });
                                                                        setAddressError("");
                                                                    }}
                                                                />
                                                            </div>

                                                            <input
                                                                type="text"
                                                                name="address-line1"
                                                                autoComplete="address-line1"
                                                                placeholder="Address"
                                                                value={addressForm.address_line1}
                                                                onChange={e => {
                                                                    setAddressForm({
                                                                        ...addressForm,
                                                                        address_line1: e.target.value
                                                                    });
                                                                    setAddressError("");
                                                                }}
                                                            />

                                                            <input
                                                                type="text"
                                                                name="address-line2"
                                                                autoComplete="address-line2"
                                                                placeholder="Apartment, suite, etc. optional"
                                                                value={addressForm.address_line2}
                                                                onChange={e => {
                                                                    setAddressForm({
                                                                        ...addressForm,
                                                                        address_line2: e.target.value
                                                                    });
                                                                    setAddressError("");
                                                                }}
                                                            />

                                                            <div className="row">
                                                                <input
                                                                    type="text"
                                                                    name="address-level2"
                                                                    autoComplete="address-level2"
                                                                    placeholder="City"
                                                                    value={addressForm.city}
                                                                    onChange={e => {
                                                                        setAddressForm({
                                                                            ...addressForm,
                                                                            city: e.target.value
                                                                        });
                                                                        setAddressError("");
                                                                    }}
                                                                />

                                                                <input
                                                                    type="text"
                                                                    name="postal-code"
                                                                    autoComplete="postal-code"
                                                                    placeholder="Postal Code"
                                                                    value={addressForm.postal_code}
                                                                    onChange={e => {
                                                                        setAddressForm({
                                                                            ...addressForm,
                                                                            postal_code: e.target.value
                                                                        });
                                                                        setAddressError("");
                                                                    }}
                                                                />

                                                            </div>

                                                            <div className="row">

                                                                <CountrySelect
                                                                    value={addressForm.country_code}
                                                                    onChange={(countryCode) => {
                                                                        updateAddressCountry(
                                                                            setAddressForm,
                                                                            countryCode,
                                                                            false
                                                                        );
                                                                        setAddressError("");
                                                                    }}
                                                                />

                                                                <StateSelect
                                                                    countryCode={addressForm.country_code}
                                                                    value={addressForm.state_code}
                                                                    onChange={(stateCode) => {
                                                                        updateAddressState(
                                                                            setAddressForm,
                                                                            addressForm.country_code,
                                                                            stateCode,
                                                                            false
                                                                        );
                                                                        setAddressError("");
                                                                    }}
                                                                />
                                                            </div>

                                                            <label className="checkbox-row">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={addressForm.is_default}
                                                                    onChange={e =>
                                                                        setAddressForm({
                                                                            ...addressForm,
                                                                            is_default: e.target.checked
                                                                        })
                                                                    }
                                                                />
                                                                Default
                                                            </label>

                                                            <div className="button-row">
                                                                <button
                                                                    type="button"
                                                                    onClick={animateThen(saveAddress)}
                                                                >
                                                                    Save
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    onClick={animateThen(() => {
                                                                        setShowAddressForm(false);
                                                                        setShowAddress(true);
                                                                    })}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* LIST of Addresses */}
                                                    {showAddress && (
                                                        <div>
                                                            {addresses.map(addr => (
                                                                <div
                                                                    key={addr.id}
                                                                    className={`account-card bg-white-09 address-card ${addr.is_default ? "is-default" : ""}`}
                                                                >
                                                                    <div className="address-content">
                                                                        {addr.is_default && (
                                                                            <div className="default-badge">
                                                                                <span>Default</span>
                                                                            </div>
                                                                        )}
                                                                        <p>{addr.first_name} {addr.last_name}</p>
                                                                        <p>{addr.address_line1}</p>
                                                                        <p>{addr.city}, {addr.province}</p>
                                                                        <p>{addr.country}</p>
                                                                    </div>

                                                                    <div className="address-actions">
                                                                        <button
                                                                            type="button"
                                                                            onClick={animateThen(() => {
                                                                                setDefault(addr.id);
                                                                                resetAccountUIState();

                                                                                if (mode === MODES.DEFAULT_ADDR) {
                                                                                    setMode(MODES.CHECKOUT);
                                                                                    setIsLeftOpen(false);
                                                                                    setIsRightOpen(true);
                                                                                }
                                                                            })}
                                                                        >
                                                                            ⭐Default
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={animateThen(() => {
                                                                                setEditingAddress(addr);
                                                                                setAddressForm(addr);
                                                                                setShowAddressForm(true);
                                                                                setShowAddress(false);
                                                                            })}
                                                                        >
                                                                            ✏️Edit
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={animateThen(() => {
                                                                                deleteAddress(addr.id);
                                                                                setShowAddressForm(false);
                                                                                setAddressError("");
                                                                                setEditingAddress(null);
                                                                            })}
                                                                        >
                                                                            🗑️Delete
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {!showAddressForm && (
                                                        <button
                                                            type="button"
                                                            className="secondary"
                                                            onClick={animateThen(() => {
                                                                setShowAddressForm(true);
                                                                setEditingAddress(null);
                                                                setShowAddress(false);
                                                                setAddressError("");
                                                                setAddressForm({
                                                                    first_name: "",
                                                                    last_name: "",
                                                                    address_line1: "",
                                                                    address_line2: "",
                                                                    city: "",
                                                                    province: "",
                                                                    postal_code: "",
                                                                    country: "",
                                                                    country_code: "",
                                                                    state_code: "",
                                                                    is_default: true
                                                                });
                                                            })}
                                                        >
                                                            + Add Address
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className="separator-line" />

                                        <button
                                            type="button"
                                            className={`address-btn ${showOrders ? "is-open" : ""}`}
                                            onClick={animateThen(() => {
                                                setShowOrders(prev => !prev);
                                                setExpandedOrderId(null);
                                            })}
                                        >
                                            🛒 Order History
                                        </button>

                                        {/* ================= ORDERS ================= */}
                                        {showOrders && (
                                            <div className="orders-section">
                                                <h3>Orders History</h3>

                                                {currentUser.orders && currentUser.orders.length > 0 ? (
                                                    <div className="orders-list">
                                                        {currentUser.orders.map(order => {
                                                            const isOpen = expandedOrderId === order.id;
                                                            const items = orderItemsMap[order.id] || [];

                                                            const displayOrderNumber =
                                                                order.public_order_number ||
                                                                "Processing";

                                                            return (
                                                                <div key={order.id} className="order-card-accordion">

                                                                    <div className="order-header">
                                                                        <div>
                                                                            <p><strong>Order #{displayOrderNumber}</strong></p>
                                                                            <p className="muted">
                                                                                {new Date(order.created_at).toLocaleDateString()}
                                                                            </p>
                                                                        </div>

                                                                        <div>
                                                                            <span className={`status ${order.status}`}>
                                                                                {getOrderStatusLabel(order.status)}
                                                                            </span>
                                                                        </div>

                                                                        <div>
                                                                            <p>${order.total_price}</p>
                                                                        </div>

                                                                        <button
                                                                            type="button"
                                                                            className={`view-btn ${isOpen ? "is-open" : ""}`}
                                                                            onClick={animateThen(() => toggleOrder(order.id))}
                                                                        >
                                                                            {isOpen ? "Hide" : "View"}
                                                                        </button>
                                                                    </div>

                                                                    {isOpen && (
                                                                        <div className="order-expanded">
                                                                            {items.length === 0 ? (
                                                                                <p>Loading items...</p>
                                                                            ) : (
                                                                                items.map(item => (
                                                                                    <div key={item.id} className="order-item">
                                                                                        <img
                                                                                            src={item.image_url}
                                                                                            className="order-item-img"
                                                                                        />

                                                                                        <div className="order-item-info">
                                                                                            <p><strong>{item.product_name}</strong></p>
                                                                                            <p>{item.variant_name}</p>
                                                                                        </div>

                                                                                        <div className="order-item-meta">
                                                                                            <p>Qty: {item.quantity}</p>
                                                                                            <p>${item.price}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <p>No orders yet</p>
                                                )}
                                            </div>
                                        )}

                                    </div>

                                    <div className="hello">
                                        <p><strong>Hi,</strong> {currentUser?.email}</p>
                                    </div>

                                    <button
                                        type="button"
                                        className="button-logout"
                                        onClick={animateThen(logout)}
                                    >
                                        Logout
                                    </button>
                                    {isMobile && (

                                        <div className="scroll-arrow-up"></div>

                                    )}
                                </>
                            ) : (
                                <>
                                    {/* =============================== Login VIEW =============================== */}
                                    <div className="menu">

                                        <h2>Login</h2>


                                        {loginError && (
                                            <p className="error">{loginError}</p>
                                        )}

                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                login();
                                            }}
                                        >
                                            <input
                                                type="email"
                                                name="email"
                                                autoComplete="email"
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        login();
                                                    }
                                                }}
                                            />

                                            <PasswordField
                                                id="login-password"
                                                name="password"
                                                autoComplete="current-password"
                                                placeholder="Password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        login();
                                                    }
                                                }}
                                            />
                                            {showForgotPassword && (
                                                <div className="account-card no-flex">
                                                    <h4>Reset Password</h4>

                                                    {forgotPasswordError && (
                                                        <p className="error">{forgotPasswordError}</p>
                                                    )}

                                                    {forgotPasswordMessage && (
                                                        <p>{forgotPasswordMessage}</p>
                                                    )}

                                                    <input
                                                        type="email"
                                                        name="reset-email"
                                                        autoComplete="email"
                                                        placeholder="Email"
                                                        value={forgotPasswordEmail}
                                                        onChange={(e) => {
                                                            setForgotPasswordEmail(e.target.value);
                                                            setForgotPasswordError("");
                                                            setForgotPasswordMessage("");
                                                        }}
                                                    />

                                                    <button
                                                        type="button"
                                                        className="reset-link-button"
                                                        disabled={forgotPasswordSubmitting || forgotPasswordCooldown > 0}
                                                        onClick={animateThen(requestPasswordReset)}
                                                    >
                                                        {forgotPasswordSubmitting ? "Sending..." : "Send Reset Link"}
                                                    </button>

                                                    {forgotPasswordCooldown > 0 && (
                                                        <div
                                                            className="reset-cooldown"
                                                            aria-live="polite"
                                                            style={{
                                                                "--cooldown-progress": `${Math.min(360, Math.max(0, ((60 - forgotPasswordCooldown) / 60) * 360))}deg`
                                                            }}
                                                        >
                                                            <span className="reset-cooldown-ring" aria-hidden="true" />
                                                            <span className="reset-cooldown-copy">
                                                                Try again in {formatCooldownTime(forgotPasswordCooldown)}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            <div className="button-row">

                                                <button
                                                    type="submit"
                                                    className="button-login"
                                                    disabled={loginSubmitting}
                                                >
                                                    Login
                                                </button>



                                                <button
                                                    type="button"
                                                    disabled={loginSubmitting}
                                                    onClick={animateThen(() => setMode(MODES.SIGNUP))}
                                                >
                                                    Create Account
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`secondary ${showForgotPassword ? "is-open" : ""}`}
                                                    disabled={forgotPasswordSubmitting}
                                                    onClick={animateThen(() => {
                                                        setShowForgotPassword(prev => !prev);
                                                        setForgotPasswordEmail(email || "");
                                                        setForgotPasswordError("");
                                                        setForgotPasswordMessage("");
                                                    })}
                                                >
                                                    Forgot Password?
                                                </button>


                                            </div>
                                        </form>

                                        <div className="separator-line" />

                                        <div className="oauth-stack">
                                            <button
                                                type="button"
                                                onClick={() => handleOAuthLogin("google")}
                                                className="oauth-btn google"
                                                disabled={Boolean(oauthSubmitting)}
                                            >
                                                <GoogleIcon />
                                                <span>Continue with Google</span>
                                            </button>
                                        </div>

                                        <div className="separator-line" />

                                        <div className="oauth-stack">
                                            <button
                                                type="button"
                                                onClick={() => handleOAuthLogin("facebook")}
                                                className="oauth-btn facebook"
                                                disabled={Boolean(oauthSubmitting)}
                                            >
                                                <FacebookIcon />
                                                <span>Continue with Facebook</span>
                                            </button>
                                        </div>

                                    </div>
                                </>
                            )}

                        </div>
                        {(isMobile && !currentUser) && (

                            <div className="scroll-arrow-up"></div>

                        )}
                    </div>
                )}

                {/* =============================== SIGN UP VIEW =============================== */}
                {!resetToken && mode === MODES.SIGNUP && (
                    <div className="account-section">
                        {isMobile ? (
                            <div className="space-gap" />
                        ) : (
                            <div className="space-gap-mini" />
                        )}

                        <div className="menu">
                            <h2>Create Account</h2>
                            {signupError && (
                                <p className="error">{signupError}</p>
                            )}
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    signUp(email, password);
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    autoComplete="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                <PasswordField
                                    id="signup-password"
                                    name="password"
                                    autoComplete="new-password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <PasswordField
                                    id="signup-confirm-password"
                                    name="confirm-password"
                                    autoComplete="new-password"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value);
                                        setSignupError("");
                                    }}
                                />

                                {showPasswordMismatch && (
                                    <p className="error">Passwords do not match</p>
                                )}
                                {password && (
                                    <div className="password-checker">
                                        <div className="password-strength-row">
                                            <span>Password strength</span>
                                            <strong className={`strength-${getPasswordStrengthText().toLowerCase()}`}>
                                                {getPasswordStrengthText()}
                                            </strong>
                                        </div>

                                        <div className="password-strength-bar">
                                            <div
                                                className={`password-strength-fill score-${passwordScore}`}
                                            />
                                        </div>

                                        <div className="password-rules">
                                            <p className={passwordRules.length ? "pass" : ""}>✓ At least 8 characters</p>
                                            <p className={passwordRules.upper ? "pass" : ""}>✓ One uppercase letter</p>
                                            <p className={passwordRules.lower ? "pass" : ""}>✓ One lowercase letter</p>
                                            <p className={passwordRules.number ? "pass" : ""}>✓ One number</p>
                                            <p className={passwordRules.special ? "pass" : ""}>✓ One special character</p>
                                        </div>
                                    </div>
                                )}

                                <div className="button-row">




                                    <button
                                        type="button"
                                        onClick={animateThen(() => setMode(MODES.ACCOUNT))}
                                    >
                                        ← Back to Login
                                    </button>

                                    <button
                                        type="submit"
                                        className="secondary sign_up"
                                        disabled={signupSubmitting}
                                    // disabled={!passwordIsStrong}
                                    >
                                        Sign Up
                                    </button>
                                </div>
                            </form>
                        </div>
                        {isMobile && (

                            <div className="scroll-arrow-up"></div>

                        )}
                    </div>
                )}

                {/* =============================== ITEM MODE VIEW =============================== */}
                {((mode === MODES.ITEM || mode === MODES.ADDED) && !isMobile) && (
                    <div>
                        <div className="space-gap-mini" />
                        <div className="item-preview" onClick={() => setMode(MODES.ITEM)}>

                            <Swiper
                                key={productCarouselKey}
                                initialSlide={0}
                                onSwiper={(swiper) => {
                                    swiperIndex.current = swiper;
                                }}
                                modules={[Pagination, A11y, Navigation, EffectFade, Keyboard]}
                                pagination={true}
                                navigation={true}
                                loop={true}
                                zoom={false}
                                keyboard={{ enabled: true }}
                                style={{
                                    '--swiper-navigation-color': 'dark-grey',
                                    '--swiper-pagination-color': 'black',
                                    '--swiper-pagination-bullet-vertical-gap': '0px',
                                    '--swiper-pagination-bottom': '0px'
                                }}
                                simulateTouch={true}
                                allowTouchMove={true}
                                touchAngle={45}
                                threshold={10}
                            >
                                {itemSelected &&
                                    getAllImages(itemSelected, selectedVariant?.color).map((url, i) => (
                                        <SwiperSlide key={i}>
                                            <img
                                                src={url}
                                                className="swiper-product-image"
                                                alt={itemSelected?.name || "Product"}
                                                loading={i === 0 ? "eager" : "lazy"}
                                                decoding="async"
                                                onDoubleClick={(e) => openFullscreenImage(e, url, i)}
                                                onTouchStart={(e) => handleImageTouchStart(e, url, i)}
                                                onTouchEnd={(e) => handleImageTouchEnd(e, url, i)}
                                                style={{
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </SwiperSlide>
                                    ))}
                            </Swiper>

                        </div>
                        {/* {scrollHintOpacity !== 0 && (
                            <div
                                className="scroll-hint"
                                style={{
                                    opacity: scrollHintOpacity,
                                    transform: `scale(${0.96 + scrollHintOpacity * 0.04})`,
                                    transition: "all 700ms cubic-bezier(0.22, 1, 0.36, 1)"
                                }}
                            >
                                <h3>Scroll for next item</h3>
                            </div>
                        )} */}
                    </div>
                )}

            </div>
        );
    };

    const rightPanel = () => {
        const cartTotal = cart.reduce((sum, i) => {
            const price = Number(i.retail_price.replace("$", ""));
            return sum + price * (i.quantity || 1);
        }, 0);

        const selectedShippingPrice = selectedShippingRate
            ? Number(selectedShippingRate.rate)
            : 0;

        const checkoutTotal = cartTotal + selectedShippingPrice;

        const defaultAddress = currentUser?.default_address;

        // detect if more than one color 
        const productColors = itemSelected
            ? getColors(itemSelected).filter(Boolean)
            : [];

        const productSizes = itemSelected
            ? getSizes(itemSelected).filter(Boolean)
            : [];

        const showColorOptions = productColors.length > 1;
        const showSizeOptions = productSizes.length > 1;

        return (
            <div className="right-section">
                {/* ITEM VIEW */}
                {(mode === MODES.ITEM || mode === MODES.ADDED) && itemSelected && (
                    <div>
                        {isMobile && (
                            <div className="item-preview" onClick={animateThen(() => setMode(MODES.ITEM))}>
                                <Swiper
                                    onSwiper={(swiper) => (swiperIndex.current = swiper)}
                                    modules={[Pagination, A11y, Navigation, EffectFade, Keyboard]}
                                    pagination={true}
                                    navigation={true}
                                    loop={true}
                                    zoom={false}
                                    keyboard={{ enabled: true }}
                                    style={{
                                        '--swiper-navigation-color': 'dark-grey',
                                        '--swiper-pagination-color': 'black',
                                        '--swiper-pagination-bullet-vertical-gap': '0px',
                                        '--swiper-pagination-bottom': '0px'
                                    }}
                                    simulateTouch={true}
                                    allowTouchMove={true}
                                    touchAngle={45}
                                    threshold={10}
                                >
                                    {itemSelected &&
                                        getAllImages(itemSelected, selectedVariant?.color).map((url, i) => (
                                            <SwiperSlide key={i}>
                                                <img
                                                    src={url}
                                                    className="swiper-product-image"
                                                    onDoubleClick={(e) => openFullscreenImage(e, url, i)}
                                                    onTouchStart={(e) => handleImageTouchStart(e, url, i)}
                                                    onTouchEnd={(e) => handleImageTouchEnd(e, url, i)}
                                                    style={{
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </SwiperSlide>
                                        ))}
                                </Swiper>
                            </div>
                        )}

                        {!isMobile ? (
                            <div className="space-gap-mini" />
                        ) : (
                            <div />
                        )}

                        <div className="menu">
                            <div className="product-header">

                                <h2 className={"product-title-peek"}>
                                    <span className="product-title-text">
                                        {itemSelected.name}
                                    </span>

                                    {showTitleFlash && (
                                        <img
                                            key={titleFlashKey}
                                            src={waveImg}
                                            alt=""
                                            className={`product-title-flash ${titleFlashDirection === "next" ? "flash-next" : "flash-prev"}`}
                                        />
                                    )}
                                </h2>

                                <div className={`price ${pricePulse ? "pulse" : ""}`}>
                                    ${selectedVariant?.retail_price}
                                    <span>{selectedVariant?.currency}</span>
                                </div>
                            </div>

                            <div className="separator-line" />

                            <div className="options-row">
                                {showColorOptions && (
                                    <div className="product-card">
                                        <label>Colors</label>

                                        <div className="pill-row">
                                            {[...productColors]
                                                .sort((a, b) => a.localeCompare(b))
                                                .map(color => {
                                                    const isActive = selectedVariant?.color === color;

                                                    return (
                                                        <button
                                                            type="button"
                                                            className={`pill ${isActive ? "active" : ""}`}
                                                            key={color}
                                                            onClick={animateThen(() => {
                                                                if (isActive) return;

                                                                const nextVariant =
                                                                    itemSelected.variants.find(v =>
                                                                        v.color === color &&
                                                                        v.size === selectedVariant?.size
                                                                    ) ||
                                                                    itemSelected.variants.find(v =>
                                                                        v.color === color
                                                                    );

                                                                if (nextVariant) {
                                                                    setSelectedVariant(nextVariant);
                                                                }

                                                                setMode(MODES.ITEM);
                                                            })}
                                                        >
                                                            {color}
                                                        </button>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                )}

                                {showSizeOptions && (
                                    <div className="product-card">
                                        {hasSizeGuide(itemSelected) ? (
                                            <button
                                                type="button"
                                                className="size-guide-label-button"
                                                onClick={openSizeGuideFullscreen}
                                            >
                                                Size Guide
                                            </button>
                                        ) : (
                                            <label>Sizes</label>
                                        )}

                                        <div className="pill-row">
                                            {productSizes.map(size => {
                                                const isActive = selectedVariant?.size === size;

                                                return (
                                                    <button
                                                        type="button"
                                                        className={`pill ${isActive ? "active" : ""}`}
                                                        key={size}
                                                        onClick={animateThen(() => {
                                                            if (isActive) return;

                                                            const nextVariant =
                                                                itemSelected.variants.find(v =>
                                                                    v.size === size &&
                                                                    v.color === selectedVariant?.color
                                                                ) ||
                                                                itemSelected.variants.find(v =>
                                                                    v.size === size
                                                                );

                                                            if (nextVariant) {
                                                                setSelectedVariant(nextVariant);
                                                            }

                                                            setMode(MODES.ITEM);
                                                        })}
                                                    >
                                                        {size}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="product-description">
                                <p>
                                    {itemSelected.description || "No description available."}
                                </p>
                            </div>

                            <div className="cart-action-wrapper">
                                {mode === MODES.ADDED ? (
                                    <div className="button-row-cart animate-in">
                                        <button
                                            type="button"
                                            onClick={animateThen(() => { setMode(MODES.CART); fetchCart(); })}
                                        >
                                            View Cart
                                        </button>

                                        <button
                                            type="button"
                                            onClick={animateThen(() => setMode(MODES.ITEM))}
                                        >
                                            Continue Shopping
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className={`add-cart-btn animate-in ${justAdded ? "added" : ""}`}
                                        onClick={animateThen(() => {
                                            addToCart(selectedVariant);
                                            setMode(MODES.ADDED);
                                        })}
                                    >
                                        Add to Cart
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* =============================== CART VIEW =============================== */}
                {(mode === MODES.CART || mode === MODES.CARTJUMP) && (
                    <div>
                        {isMobile ? (
                            <div className="space-gap" />
                        ) : (
                            <div className="space-gap-mini" />
                        )}

                        <div className="menu">
                            <div onClick={animateLongThen(handleToggle)}>
                                <h2 className="glass-thick glass-header-title">
                                    Cart
                                </h2>
                            </div>

                            <div className="product-card">
                                {cart.length === 0 ? (
                                    <p>Cart is empty</p>
                                ) : (
                                    cart.map((item) => {
                                        const match = getVariantById(item.variant_id);

                                        const imageUrl =
                                            item.image_url ||
                                            match?.variant?.images?.[0]?.url ||
                                            match?.product?.thumbnail_url;

                                        return (
                                            <div className="cart-item" key={item.variant_id}>
                                                <img
                                                    src={imageUrl}
                                                    alt={item.name}
                                                    className="cart-item-image"
                                                />

                                                <div className="cart-item-info">
                                                    <div className="cart-item-name">
                                                        {item.name}
                                                    </div>

                                                    <div className="cart-item-qty">
                                                        Qty: {item.quantity}
                                                    </div>
                                                </div>

                                                <div className="cart-item-actions">
                                                    <button
                                                        type="button"
                                                        className="qty-btn"
                                                        onClick={animateThen(() => removeFromCart(item))}
                                                    >
                                                        −
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="qty-btn"
                                                        onClick={animateThen(() => increaseCartItem(item))}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}

                                <p>Total: ${cartTotal}</p>
                            </div>

                            <button
                                type="button"
                                className="bold-button"
                                onClick={animateThen(() => {
                                    setMode(MODES.CHECKOUT);
                                    resetShippingSelection();
                                    setCheckoutError("");
                                    setReturnPolicyAccepted(false);
                                    dismissOrderMessage();
                                })}
                            >
                                Checkout
                            </button>

                            <button
                                type="button"
                                className="bold-button"
                                onClick={animateThen(() => {
                                    if (mode === MODES.CARTJUMP) {
                                        setMode(MODES.HOME);
                                        setIsLeftOpen(false);
                                        setIsRightOpen(false);
                                        updateChevron();
                                    } else {
                                        setMode(MODES.ITEM);
                                        setIsLeftOpen(true);
                                        setIsRightOpen(true);
                                    }
                                })}
                            >
                                Continue Shopping
                            </button>
                        </div>
                    </div>
                )}

                {/* =============================== CHECKOUT VIEW =============================== */}
                {mode === MODES.CHECKOUT && (
                    <div>
                        {isMobile ? (
                            <div className="space-gap" />
                        ) : (
                            <div className="space-gap-mini" />
                        )}

                        <div className="menu">
                            <div onClick={animateLongThen(handleToggle)}>
                                <h2 className="glass-thick glass-header-title">
                                    Checkout
                                </h2>
                            </div>

                            {checkoutError && (
                                <p className="error">{checkoutError}</p>
                            )}

                            <h4>Order Summary</h4>

                            <div className="account-card">
                                <p>Items: {cart.length}</p>
                                <p>Subtotal: ${cartTotal.toFixed(2)}</p>
                                <p>Shipping: ${selectedShippingPrice.toFixed(2)}</p>
                                <p>
                                    <strong>Total: ${checkoutTotal.toFixed(2)} CAD</strong>
                                </p>
                            </div>

                            <div className="separator-line" />

                            <h4>Email</h4>

                            {currentUser ? (
                                <div className="account-card checkout-contact-card">
                                    <label
                                        className="checkout-card-title"
                                        htmlFor="checkout-email-current"
                                    >
                                        Logged in as
                                    </label>

                                    <input
                                        id="checkout-email-current"
                                        type="email"
                                        name="email"
                                        autoComplete="email"
                                        value={currentUser.email}
                                        disabled
                                        className="checkout-email-input"
                                    />

                                    <p className="checkout-card-note">
                                        Order updates will be sent here
                                    </p>
                                </div>
                            ) : (
                                <div className="account-card checkout-auth-card">
                                    <div className="checkout-guest-panel">
                                        <label
                                            className="checkout-card-title"
                                            htmlFor="checkout-email-guest"
                                        >
                                            Checkout as guest
                                        </label>

                                        <input
                                            id="checkout-email-guest"
                                            type="email"
                                            name="email"
                                            autoComplete="email"
                                            placeholder="Email for order updates"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="checkout-email-input"
                                        />

                                        <p className="checkout-card-note">
                                            You'll receive order tracking here
                                        </p>
                                    </div>

                                    <div className="checkout-auth-divider" aria-hidden="true">
                                        <span>or</span>
                                    </div>

                                    <div className="checkout-oauth-panel">
                                        <button
                                            type="button"
                                            onClick={() => handleOAuthLogin("google")}
                                            className="oauth-btn google"
                                        >
                                            <GoogleIcon />
                                            <span>Continue with Google</span>
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() => handleOAuthLogin("facebook")}
                                            className="oauth-btn facebook"
                                        >
                                            <FacebookIcon />
                                            <span>Continue with Facebook</span>
                                        </button>
                                    </div>
                                </div>
                            )}

                            <h4>Shipping Address</h4>
                            <div>
                                {currentUser && (
                                    <div>

                                        <div className="account-card">
                                            {defaultAddress ? (
                                                <div>
                                                    <p>
                                                        {defaultAddress.first_name}{" "}
                                                        {defaultAddress.last_name}
                                                    </p>

                                                    <p>{defaultAddress.address_line1}</p>

                                                    <p>
                                                        {defaultAddress.city},{" "}
                                                        {defaultAddress.province}
                                                    </p>

                                                    <p>
                                                        {defaultAddress.postal_code},{" "}
                                                        {defaultAddress.country}
                                                    </p>

                                                    {!defaultAddress.country_code && (
                                                        <p className="error">
                                                            This address needs a country code before shipping can be calculated.
                                                        </p>
                                                    )}

                                                    <button
                                                        type="button"
                                                        className="address-button"
                                                        onClick={animateThen(() => {
                                                            setMode(MODES.DEFAULT_ADDR);
                                                            fetchUser();
                                                            fetchAddresses();
                                                            setIsRightOpen(false);
                                                            setIsLeftOpen(true);
                                                            setShowAddressBook(true);
                                                            setShowAddress(true);
                                                            resetShippingSelection();
                                                        })}
                                                    >
                                                        Change Default Address
                                                    </button>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p>No default address</p>

                                                    <button
                                                        type="button"
                                                        className="address-button"
                                                        onClick={animateThen(() => {
                                                            setMode(MODES.ADD_ADDR);
                                                            fetchUser();
                                                            setIsRightOpen(false);
                                                            setIsLeftOpen(true);
                                                            setShowAddressBook(true);
                                                            setShowAddressForm(true);
                                                            resetShippingSelection();

                                                            setAddressForm({
                                                                first_name: "",
                                                                last_name: "",
                                                                address_line1: "",
                                                                address_line2: "",
                                                                city: "",
                                                                province: "",
                                                                postal_code: "",
                                                                country: "",
                                                                country_code: "",
                                                                state_code: "",
                                                                is_default: true
                                                            });
                                                        })}
                                                    >
                                                        Add Address
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {!currentUser && (
                                    <div>

                                        <div className="address-form">
                                            <div className="row">
                                                <input
                                                    type="text"
                                                    name="shipping-given-name"
                                                    autoComplete="shipping given-name"
                                                    placeholder="First Name"
                                                    value={guestShipping.first_name}
                                                    onChange={(e) =>
                                                        updateGuestShipping("first_name", e.target.value)
                                                    }
                                                />

                                                <input
                                                    type="text"
                                                    name="shipping-family-name"
                                                    autoComplete="shipping family-name"
                                                    placeholder="Last Name"
                                                    value={guestShipping.last_name}
                                                    onChange={(e) =>
                                                        updateGuestShipping("last_name", e.target.value)
                                                    }
                                                />
                                            </div>

                                            <input
                                                type="text"
                                                name="shipping-address-line1"
                                                autoComplete="shipping address-line1"
                                                placeholder="Address"
                                                value={guestShipping.address_line1}
                                                onChange={(e) =>
                                                    updateGuestShipping("address_line1", e.target.value)
                                                }
                                            />

                                            <input
                                                type="text"
                                                name="shipping-address-line2"
                                                autoComplete="shipping address-line2"
                                                placeholder="Apartment, suite, etc. optional"
                                                value={guestShipping.address_line2}
                                                onChange={(e) =>
                                                    updateGuestShipping("address_line2", e.target.value)
                                                }
                                            />

                                            <div className="row">
                                                <input
                                                    type="text"
                                                    name="shipping-address-level2"
                                                    autoComplete="shipping address-level2"
                                                    placeholder="City"
                                                    value={guestShipping.city}
                                                    onChange={(e) =>
                                                        updateGuestShipping("city", e.target.value)
                                                    }
                                                />

                                                <input
                                                    type="text"
                                                    name="shipping-postal-code"
                                                    autoComplete="shipping postal-code"
                                                    placeholder="Postal Code"
                                                    value={guestShipping.postal_code}
                                                    onChange={(e) =>
                                                        updateGuestShipping("postal_code", e.target.value)
                                                    }
                                                />
                                            </div>



                                            <div className="row">

                                                <CountrySelect
                                                    value={guestShipping.country_code}
                                                    onChange={(countryCode) =>
                                                        updateAddressCountry(
                                                            setGuestShipping,
                                                            countryCode,
                                                            true
                                                        )
                                                    }
                                                />

                                                <StateSelect
                                                    countryCode={guestShipping.country_code}
                                                    value={guestShipping.state_code}
                                                    onChange={(stateCode) =>
                                                        updateAddressState(
                                                            setGuestShipping,
                                                            guestShipping.country_code,
                                                            stateCode,
                                                            true
                                                        )
                                                    }
                                                />

                                            </div>
                                            {countriesError && (
                                                <p className="error">{countriesError}</p>
                                            )}


                                        </div>
                                    </div>
                                )}
                            </div>

                            <h4>Shipping</h4>

                            <div className="account-card no-flex">
                                {shippingError && (
                                    <p className="error">{shippingError}</p>
                                )}
                                <button
                                    type="button"
                                    disabled={shippingLoading}
                                    onClick={animateThen(calculateShippingRates)}
                                    className="secondary"
                                >
                                    {shippingLoading ? "Calculating..." : "Calculate Shipping"}
                                </button>



                                {shippingRates.length > 0 && (
                                    <div className="shipping-options">
                                        {shippingRates.map((rate, index) => {
                                            const rateKey =
                                                rate.id ||
                                                rate.shipping ||
                                                `${rate.shipping_method_name}-${rate.rate}-${index}`;

                                            const isSelected = selectedShippingRate === rate;

                                            return (
                                                <button
                                                    type="button"
                                                    key={rateKey}
                                                    className={`shipping-rate ${isSelected ? "active" : ""}`}
                                                    onClick={animateThen(() => setSelectedShippingRate(rate))}
                                                >
                                                    <span>
                                                        {rate.shipping_method_name || rate.name || "Shipping"}

                                                    </span>
                                                    <span>
                                                        ${rate.rate} {rate.currency || "CAD"}
                                                    </span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            <h4>Billing Address</h4>
                            <div className="account-card no-flex">
                                <label className="checkbox-row">
                                    <input
                                        type="checkbox"
                                        checked={sameBilling}
                                        onChange={(e) => setSameBilling(e.target.checked)}
                                    />
                                    Billing address same as shipping
                                </label>
                                <div>

                                    {!sameBilling && (
                                        <div className="address-form">
                                            {billingError && (
                                                <p className="error">{billingError}</p>
                                            )}

                                            <div className="row">
                                                <input
                                                    type="text"
                                                    name="billing-given-name"
                                                    autoComplete="billing given-name"
                                                    placeholder="First Name"
                                                    value={billingForm.first_name}
                                                    onChange={e => {
                                                        updateBillingForm("first_name", e.target.value);
                                                        setBillingError("");
                                                    }}
                                                />

                                                <input
                                                    type="text"
                                                    name="billing-family-name"
                                                    autoComplete="billing family-name"
                                                    placeholder="Last Name"
                                                    value={billingForm.last_name}
                                                    onChange={e => {
                                                        updateBillingForm("last_name", e.target.value);
                                                        setBillingError("");
                                                    }}
                                                />
                                            </div>

                                            <input
                                                type="text"
                                                name="billing-address-line1"
                                                autoComplete="billing address-line1"
                                                placeholder="Address"
                                                value={billingForm.address_line1}
                                                onChange={e => {
                                                    updateBillingForm("address_line1", e.target.value);
                                                    setBillingError("");
                                                }}
                                            />

                                            <input
                                                type="text"
                                                name="billing-address-line2"
                                                autoComplete="billing address-line2"
                                                placeholder="Apartment, suite, etc. optional"
                                                value={billingForm.address_line2}
                                                onChange={e => {
                                                    updateBillingForm("address_line2", e.target.value);
                                                    setBillingError("");
                                                }}
                                            />

                                            <div className="row">
                                                <input
                                                    type="text"
                                                    name="billing-address-level2"
                                                    autoComplete="billing address-level2"
                                                    placeholder="City"
                                                    value={billingForm.city}
                                                    onChange={e => {
                                                        updateBillingForm("city", e.target.value);
                                                        setBillingError("");
                                                    }}
                                                />

                                                <input
                                                    type="text"
                                                    name="billing-postal-code"
                                                    autoComplete="billing postal-code"
                                                    placeholder="Postal Code"
                                                    value={billingForm.postal_code}
                                                    onChange={e => {
                                                        updateBillingForm("postal_code", e.target.value);
                                                        setBillingError("");
                                                    }}
                                                />
                                            </div>



                                            <div className="row">
                                                <CountrySelect
                                                    value={billingForm.country_code}
                                                    onChange={(countryCode) => {
                                                        updateAddressCountry(
                                                            setBillingForm,
                                                            countryCode,
                                                            false
                                                        );
                                                        setBillingError("");
                                                    }}
                                                />

                                                <StateSelect
                                                    countryCode={billingForm.country_code}
                                                    value={billingForm.state_code}
                                                    onChange={(stateCode) => {
                                                        updateAddressState(
                                                            setBillingForm,
                                                            billingForm.country_code,
                                                            stateCode,
                                                            false
                                                        );
                                                        setBillingError("");
                                                    }}
                                                />
                                            </div>
                                            {countriesError && (
                                                <p className="error">{countriesError}</p>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>


                            <ReturnPolicyAgreement
                                accepted={returnPolicyAccepted}
                                onChange={(accepted) => {
                                    setReturnPolicyAccepted(accepted);

                                    if (accepted) {
                                        setCheckoutError("");
                                    }
                                }}
                            />

                            <button
                                type="button"
                                className="bold-button"
                                disabled={placingOrder || !returnPolicyAccepted}
                                onClick={animateThen(checkout)}
                            >
                                {placingOrder ? "Placing Order..." : "Place Order"}
                            </button>

                            <button
                                type="button"
                                onClick={animateThen(() => { setMode(MODES.CART); fetchCart(); })}
                            >
                                Back to Cart
                            </button>
                        </div>
                    </div>
                )}
                {isMobile && (
                    <div className="scroll-arrow"></div>
                )}
            </div>
        );
    };

    return (
        <div className="App">
            <img
                src={waveImg}
                alt=""
                aria-hidden="true"
                loading="eager"
                decoding="async"
                className="product-title-flash-preload"
            />

            {fullscreenImage && (
                <div
                    className="fullscreen-image-overlay"
                    onClick={handleFullscreenOverlayClick}
                    onTouchStart={handleFullscreenTouchStart}
                    onTouchMove={handleFullscreenTouchMove}
                    onTouchEnd={handleFullscreenTouchEnd}
                    onTouchCancel={handleFullscreenTouchCancel}
                >
                    <button
                        type="button"
                        className="fullscreen-close-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            closeFullscreenImage();
                        }}
                    >
                        ✕
                    </button>

                    <img
                        src={fullscreenImage}
                        className="fullscreen-image"
                        onClick={(e) => e.stopPropagation()}
                        onDoubleClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            closeFullscreenImage();
                        }}
                        alt=""
                    />
                </div>
            )}
            <div className="gesture-zone" />
            <div className="navbar">
                {isRefreshing && (
                    <div className="refresh-overlay">
                        <div className="refresh-box">
                            Refreshing...
                        </div>
                    </div>
                )}
                {toast && (
                    <div className="toast">
                        {toast}
                    </div>
                )}
                {orderMessage && (
                    <div
                        className={`order-message-dismiss-layer ${siteAlert.type === "about" ? "about-alert-layer" : ""}`}
                        onClick={dismissOrderMessage}
                        role="button"
                        tabIndex={0}
                        aria-label="Dismiss message"
                    >
                        <div
                            className={`order-success-message ${siteAlert.type === "about" ? "about-success-message" : ""}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                type="button"
                                className="alert-close-btn"
                                onClick={dismissOrderMessage}
                                aria-label="Close message"
                            >{"\u00d7"}</button>

                            <div className="success-icon">{siteAlert.icon}</div>

                            <div className="success-content">
                                <h3>{siteAlert.title}</h3>
                                <p>{renderAlertMessage(orderMessage)}</p>
                            </div>
                        </div>
                    </div>
                )}


                <div className="container">

                    <div className="navbar-content">

                        {/* LEFT */}
                        <div className="nav-left">
                            <button className="nav-card chevron" onClick={animateThen(handleToggle)}>
                                {chevron ? '+' : '<'}
                            </button>
                        </div>

                        {/* CENTER */}

                        <div className="nav-center">

                            <div
                                className={`nav-title-wrapper ${mode !== MODES.HOME
                                    ? "glass-thick header-toggle nav-title-bg"
                                    : ""
                                    }`}
                                onClick={animateThen(handleHomeClick)}
                            >
                                <h1
                                    className="nav-title"
                                >
                                    {/* Holy Threads */}
                                </h1>
                                <img src={logo} />
                            </div>

                        </div>

                        <div className="nav-center-blocking" />

                        {/* RIGHT */}
                        <div className="nav-right">




                            <button className="nav-card" onClick={animateThen(handleAccClick)}>👤</button>

                            <button
                                className={`nav-card ${cartPulse ? "pulse" : ""}`}
                                onClick={animateThen(handleCartClick)}
                            >
                                🛒
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <main className="main">
                <div className="container">

                    <div ref={leftPanelRef} className={`side-panel left ${isLeftOpen ? "open" : ""} ${(mode === MODES.ACCOUNT || mode === MODES.DEFAULT_ADDR || mode === MODES.ADD_ADDR) ? "full" : ""} ${(mode === MODES.ITEM || mode === MODES.ADDED) ? "item-view" : ""}`}>
                        {leftPanel()}
                    </div>

                    <div ref={rightPanelRef} className={`side-panel right ${isRightOpen ? "open" : ""} ${mode === MODES.CARTJUMP ? "full" : ""} ${(mode === MODES.ITEM || mode === MODES.ADDED) ? "item-view" : ""}`}>
                        {rightPanel()}
                    </div>
                    {isMobile && (
                        <div className="space-gap-mini" />
                    )}

                    {/* <table className="clothes-table">
                        <tbody>
                            {renderClothesRow()}
                        </tbody>
                    </table> */}
                    <div className="home-product-pager">
                        <Swiper
                            key={`${isMobile}-${colunmSize[colunmIndex]}-${clothes.length}`}
                            modules={[Pagination, Navigation, Mousewheel, A11y]}
                            pagination={{
                                clickable: true
                            }}
                            navigation={!isMobile}
                            loop={getHomePages().length > 1}
                            mousewheel={{
                                forceToAxis: false,
                                thresholdDelta: 25,
                                sensitivity: 1,
                                releaseOnEdges: false
                            }}
                            slidesPerView={1}
                            spaceBetween={18}
                            speed={420}
                            resistanceRatio={0.75}
                            allowTouchMove={true}
                            simulateTouch={true}
                            style={{
                                '--swiper-navigation-color': '#000'
                            }}
                        >
                            {getHomePages().map((pageItems, pageIndex) => (
                                <SwiperSlide key={pageIndex}>
                                    {renderHomePage(pageItems, pageIndex)}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </main>
        </div>
    );
};
